import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.experiments');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Service } from "src/libs/portal/season/service";

const POSE_TEST_EDGES = [
    [11, 12], [11, 13], [12, 14], [11, 23], [12, 24], [23, 24],
];
const POSE_TEST_VISIBLE_IDS = new Set([11, 12, 13, 14, 23, 24]);

@Component({ standalone: false,
    selector: 'wiz-page-xray-experiments',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.experiments/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100vh;
}

.training-page {
  width: 100%;
  min-height: calc(100vh + 1px);
  overflow-x: clip;
}

button,
select,
input,
summary {
  transition: border-color 120ms ease, background-color 120ms ease, color 120ms ease, opacity 120ms ease;
}

button:focus-visible,
select:focus-visible,
input:focus-visible,
summary:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

input[type=range] {
  min-height: 24px;
}

details > summary {
  list-style: none;
}

details > summary::-webkit-details-marker {
  display: none;
}

.details-chevron {
  transition: transform 160ms ease;
}

details[open] .details-chevron {
  transform: rotate(180deg);
}

.dataset-progress {
  height: 8px;
  appearance: none;
  overflow: hidden;
  border: 0;
  border-radius: 999px;
  background: #e2e8f0;
}

.dataset-progress::-webkit-progress-bar {
  border-radius: 999px;
  background: #e2e8f0;
}

.dataset-progress::-webkit-progress-value {
  border-radius: 999px;
}

.dataset-progress--normal::-webkit-progress-value {
  background: #10b981;
}

.dataset-progress--normal::-moz-progress-bar {
  border-radius: 999px;
  background: #10b981;
}

.dataset-progress--abnormal::-webkit-progress-value {
  background: #f43f5e;
}

.dataset-progress--abnormal::-moz-progress-bar {
  border-radius: 999px;
  background: #f43f5e;
}

@media (prefers-reduced-motion: reduce) {
  button,
  select,
  input,
  summary,
  .details-chevron {
    transition: none;
  }
}`],
})
export class PageXrayExperimentsComponent implements OnInit, OnDestroy {
    public readonly legacyCoordinateWorkflowVisible = false;
    public workspaceTab: 'training' | 'dataset' = 'training';
    public activeTab: 'posture' | 'detector' | 'judgement' = 'detector';
    public summary: any = this.emptySummary();
    public readiness: any = { ready: false, minimum: { normal: 30, abnormal: 60 }, missing: { normal: 30, abnormal: 60 } };
    public capabilities: any = { profiles: [], detector_labels: {} };
    public poseModels: any = { models: [], ready_count: 0, total_count: 4, import_job: { status: 'idle' } };
    public reviewedDataset: any = { reviewed: 0, normal: 0, abnormal: 0, artifact: { available: false, fresh: false } };
    public trainingDatasetKind: 'source' | 'annotated' = 'source';
    public trainingDatasetMedia: 'image' | 'video' = 'image';
    public trainingDatasetItems: any[] = [];
    public trainingDatasetItemsTotal = 0;
    public trainingDatasetItemsOffset = 0;
    public readonly trainingDatasetItemsLimit = 24;
    public trainingDatasetDecision = '';
    public trainingDatasetQuery = '';
    public trainingDatasetItemsLoading = false;
    public trainingDatasetThumbnailLoadLimit = 4;
    public trainingDatasetLoaded = false;
    public trainingDatasetViewerItem: any = null;
    public trainingDatasetViewerDetail: any = null;
    public trainingDatasetViewerLoading = false;
    public trainingDatasetViewerTime = 0;
    public trainingDatasetViewerShowPose = true;
    public trainingDatasetViewerShowDetector = true;
    public trainingDatasetViewerThumbnailLoaded = false;
    public trainingDatasetViewerFullImageLoaded = false;
    public trainingDatasetViewerLivePosePoints: any[] = [];
    public trainingDatasetViewerLiveDetectorPolygon: any = null;
    public trainingDatasetViewerLiveSourceTime = -1;
    public trainingDatasetViewerLiveBusy = false;
    public trainingDatasetViewerLiveError = '';
    private trainingDatasetViewerLiveGeneration = 0;
    private trainingDatasetViewerLiveTrackingId = '';
    private trainingDatasetViewerLiveLastRequestedAt = 0;
    public trainingDatasetBuildBusy = false;
    public trainingDatasetUploadBusy = false;
    public trainingDatasetUploadProgress = { current: 0, total: 0 };
    public trainingDatasetImportedItems: any[] = [];
    public trainingDatasetImportedFileCount = 0;
    public trainingDatasetDuplicateCount = 0;
    public trainingDatasetPredictionFailureCount = 0;
    public trainingDatasetSkippedFileCount = 0;
    public poseEpochs = 50;
    public poseTrainingMediaMode: 'image' | 'video' | 'all' = 'all';
    public poseTrainingPrepared = false;
    public configuration: any = {
        profile: 'operating_posture_classifier', epochs: 30, image_size: 224,
        pose_model: 'yolo26s-pose',
        advanced_split: { train: 70, validation: 15, test: 15 }
    };
    public advancedOpen = false;
    public experiments: any[] = [];
    public jobs: any[] = [];
    public selectedExperiment: any = null;
    public selectedJob: any = null;
    public metrics: any = null;
    public evaluationSummary: any = null;
    public artifacts: any[] = [];
    public candidateModels: any[] = [];
    public activeModel: any = null;
    public yoloPromotion: any = {
        checks: {},
        technical_ready: false,
        ready_for_operating_promotion: false,
        promotion_allowed: false,
        operating_model_replaced: false,
        deployment_mode: 'trained',
    };
    public metadata: any = { candidate_groups: [], distributions: { persons: [], sessions: [] }, external_test: {} };
    public metadataRecords: any[] = [];
    public batchSummary: any = { total: 0, analyzed_count: 0, posture_distributions: {}, training_eligibility: { heads: {} } };
    public pilotSummary: any = {
        combined_total: 0, original_batch_count: 0, public_file_count: 0,
        public_source_file_count: 0, public_queued_count: 0,
        public_prediction_pending_count: 0, public_category_counts: {},
        public_reviewed_count: 0, public_review_remaining_count: 0,
        public_detector_reviewed_count: 0,
        public_detector_positive_count: 0,
        public_detector_strict_gt_count: 0,
        public_detector_linked_baseline_count: 0,
        reviewed_detector_label_count: 0,
        public_detector_hard_negative_count: 0,
        public_detector_remaining_count: 0,
        detector_video_training_gt_count: 0,
        detector_video_training_ready: false,
        pilot_queue_count: 0, manifest_eligible_count: 0,
        queue_counts: {}, training_ready: false, detector_training_ready: false
    };
    public pilotSummaryLoaded = false;
    public pilotSummaryError = '';
    public detectorPreparation: any = null;
    public detectorTrainingJob: any = { status: 'idle' };
    public serverTrainingResources: any = {
        status: 'checking', label: '서버 확인 중', message: '서버 자원을 확인하고 있습니다.',
        start_allowed: false, stop_recommended: false,
        available_memory_gb: 0, memory_threshold_gb: 4,
        swap_total_gb: 0, load_1m: 0, load_5m: 0, load_threshold: 25,
    };
    public detectorTrainingBusy = false;
    public detectorTrainingStopping = false;
    public detectorCandidateModels: any[] = [];
    public detectorEvaluationModelSha = '';
    public detectorCandidateTestModelSha = '';
    public detectorCandidateTestFile: File | null = null;
    public detectorCandidateTestVideoUrl = '';
    public detectorCandidateTestResult: any = null;
    public detectorCandidateTestFrame: any = null;
    public detectorCandidateTestBusy = false;
    public detectorCandidateTestPassBusy = false;
    public detectorCandidateTestPassed = false;
    public detectorCandidateRealtimeOn = false;
    public detectorCandidateRealtimeBusy = false;
    public detectorCandidateRealtimeError = '';
    public detectorCandidateRealtimeFrame: any = null;
    public detectorCandidateRealtimeFramesProcessed = 0;
    public poseCandidateTestPassBusy = false;
    public poseCandidateTestPassed = false;
    public poseCandidateVideoFile: File | null = null;
    public poseCandidateVideoUrl = '';
    public poseCandidateVideoResult: any = null;
    public poseCandidateVideoFrame: any = null;
    public poseCandidateVideoBusy = false;
    public poseCandidateRealtimeOn = false;
    public poseCandidateRealtimeBusy = false;
    public poseCandidateRealtimeError = '';
    public poseCandidateRealtimeFrame: any = null;
    public poseCandidateRealtimeFramesProcessed = 0;
    public judgementCandidateTestExperimentId = '';
    public judgementCandidateTestFile: File | null = null;
    public judgementCandidateTestVideoUrl = '';
    public judgementCandidateTestFrame: any = null;
    public judgementCandidateTestBusy = false;
    public judgementCandidateTestRunning = false;
    public judgementCandidateTestError = '';
    public judgementCandidateEvaluatedFrameCount = 0;
    public judgementCandidateTestPassBusy = false;
    public judgementCandidateTestPassed = false;
    public detectorCandidateTestGtMode = false;
    public detectorCandidateTestGtPoints: any[] = [null, null, null, null];
    public detectorCandidateTestGtCornerSources: string[] = ['MISSING', 'MISSING', 'MISSING', 'MISSING'];
    public detectorCandidateTestGtSelectedCorner = 0;
    public readonly detectorCandidateGtCornerLabels = ['1 좌상', '2 우상', '3 우하', '4 좌하'];
    public detectorCandidateTestGtSaving = false;
    public detectorCandidateTestFailureSaved: any = null;
    public detectorCandidateMovementPhase: 'before' | 'moving' | 'after' = 'moving';
    public batchJob: any = null;
    public batchBusy = false;
    public publicQueueJob: any = null;
    public publicQueueBusy = false;
    public externalLabel: 'pass' | 'fail' = 'pass';
    public externalFile: File | null = null;
    public externalMetrics: any = null;
    public pendingFiles: Array<{ file: File; relativePath: string; url: string }> = [];
    public importLabel: 'pass' | 'fail' = 'pass';
    public importResult: any = null;
    public loading = false;
    public saveBusy = false;
    public startBusy = false;
    public importBusy = false;
    public actionBusy = false;
    public poseWeightBusy = false;
    public errorMessage = '';
    public notice = '';
    private pollTimer: any = null;
    private batchPollTimer: any = null;
    private publicQueuePollTimer: any = null;
    private detectorTrainingPollTimer: any = null;
    private poseWeightPollTimer: any = null;
    private trainingDatasetPollTimer: any = null;
    private trainingDatasetLoadGeneration = 0;
    private detectorCandidateRealtimeTimer: any = null;
    private detectorCandidateRealtimeGeneration = 0;
    private detectorCandidateRealtimeTrackingId = '';
    private poseCandidateRealtimeTimer: any = null;
    private poseCandidateRealtimeGeneration = 0;
    private poseCandidateRealtimeTrackingId = '';
    private judgementCandidateTestTimer: any = null;
    private judgementCandidateTestGeneration = 0;
    private readonly freshTrainingStateApi = '/wiz/api/page.xray.experiments_runtime_v8/load';
    private readonly freshTrainingActionApi = '/wiz/api/page.xray.experiments_runtime_v8/request';
    private readonly judgementCandidateActionApi = '/wiz/api/page.xray.experiments_runtime_v10/request';
    private readonly datasetUploadApi = '/wiz/api/page.xray.dataset_upload_runtime_v1/import_media';
    private readonly modelTabStorageKey = 'xray.training.model-tab';

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( TranslateService    )         public translate: TranslateService    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        const query = new URLSearchParams(window.location.search);
        if (query.get('workspace') === 'dataset') {
            this.workspaceTab = 'dataset';
        }
        const requestedModelTab = query.get('model');
        const modelTab = this.isModelTab(requestedModelTab)
            ? requestedModelTab
            : this.readStoredModelTab();
        if (modelTab) {
            this.activeTab = modelTab;
            this.storeModelTab(modelTab);
        }
        if (this.workspaceTab === 'dataset') {
            await Promise.all([
                this.loadTrainingDatasetStatus(true),
                this.loadTrainingDatasetItems(),
            ]);
        }
        await this.loadState();
        if (this.activeTab !== 'detector') {
            await this.setTab(this.activeTab);
        }
        await this.loadPilotSummary(true);
        if (this.detectorTrainingRunning()) this.startDetectorTrainingPolling();
        if (this.poseWeightImporting()) this.startPoseWeightPolling();
        if (this.selectedJob?.status === 'completed') await this.loadResults();
    }

    public ngOnDestroy() {
        this.stopPolling();
        this.stopBatchPolling();
        this.stopPublicQueuePolling();
        this.stopDetectorTrainingPolling();
        this.stopPoseWeightPolling();
        this.stopTrainingDatasetPolling();
        this.clearPendingPreviews();
        this.clearDetectorCandidateTestVideo();
        this.stopDetectorCandidateRealtime(false);
        this.stopPoseCandidateRealtime(false);
        this.clearPoseCandidateVideo();
        this.clearJudgementCandidateTestVideo();
    }

    public go(path: string) { this.service.href(path); }

    public async selectWorkspaceTab(tab: 'training' | 'dataset') {
        this.workspaceTab = tab;
        const url = new URL(window.location.href);
        if (tab === 'dataset') url.searchParams.set('workspace', 'dataset');
        else url.searchParams.delete('workspace');
        window.history.replaceState(window.history.state, '', url.toString());
        await this.service.render();
        if (tab === 'dataset') {
            await Promise.all([
                this.loadTrainingDatasetStatus(true),
                this.trainingDatasetLoaded ? Promise.resolve() : this.loadTrainingDatasetItems(),
            ]);
        }
    }

    public guardTrainingDatasetUploadMenu(event: Event) {
        if (this.trainingDatasetUploadBusy) event.preventDefault();
    }

    public closeTrainingDatasetUploadMenu() {
        const menu = document.querySelector(
            '[data-testid="training-dataset-upload-menu"]'
        ) as HTMLDetailsElement | null;
        if (menu) menu.open = false;
    }

    public isSupportedTrainingDatasetFile(file: File) {
        const mime = String(file?.type || '').toLowerCase();
        if (mime.startsWith('image/') || mime.startsWith('video/')) return true;
        const suffix = String(file?.name || '').toLowerCase().split('.').pop();
        return [
            'jpg', 'jpeg', 'png', 'webp', 'bmp', 'tif', 'tiff',
            'mp4', 'webm', 'mov',
        ].includes(suffix || '');
    }

    public async importTrainingDatasetFiles(event: Event) {
        const input = event.target as HTMLInputElement;
        const selectedFiles = Array.from(input.files || []);
        const files = selectedFiles.filter(
            file => this.isSupportedTrainingDatasetFile(file)
        );
        this.closeTrainingDatasetUploadMenu();
        this.trainingDatasetSkippedFileCount =
            selectedFiles.length - files.length;
        if (!files.length || this.trainingDatasetUploadBusy) {
            input.value = '';
            if (selectedFiles.length && !files.length) {
                this.errorMessage =
                    '선택한 항목에 지원하는 사진 또는 동영상이 없습니다.';
                await this.service.render();
            }
            return;
        }
        this.trainingDatasetUploadBusy = true;
        this.trainingDatasetUploadProgress = { current: 0, total: files.length };
        this.trainingDatasetImportedItems = [];
        this.trainingDatasetImportedFileCount = 0;
        this.trainingDatasetDuplicateCount = 0;
        this.trainingDatasetPredictionFailureCount = 0;
        this.notice = '';
        this.errorMessage = '';
        await this.service.render();
        const errors: string[] = [];
        for (const file of files) {
            try {
                const form = new FormData();
                form.append('file', file, file.name);
                const response = await fetch(this.datasetUploadApi, {
                    method: 'POST',
                    body: form,
                    credentials: 'same-origin',
                });
                const payload = await response.json();
                const code = Number(payload?.code || response.status || 500);
                const data = payload?.data || {};
                if (code !== 200) {
                    throw new Error(
                        data?.message
                        || file.name + ' 파일을 추가하지 못했습니다.'
                    );
                }
                const result = data?.result || {};
                this.reviewedDataset = data?.dataset || this.reviewedDataset;
                this.trainingDatasetImportedItems.push(
                    ...(result?.review_items || [])
                );
                this.trainingDatasetImportedFileCount += result?.imported ? 1 : 0;
                this.trainingDatasetDuplicateCount += result?.duplicate ? 1 : 0;
                this.trainingDatasetPredictionFailureCount += Number(
                    result?.prediction_failure_count || 0
                );
            } catch (error: any) {
                errors.push(
                    file.name + ': '
                    + this.callError(error, '등록하지 못했습니다.')
                );
            }
            this.trainingDatasetUploadProgress.current += 1;
            await this.service.render();
        }
        input.value = '';
        this.trainingDatasetUploadBusy = false;
        if (this.trainingDatasetImportedItems.length) {
            this.trainingDatasetMedia = this.trainingDatasetImportedItems[0]
                ?.media_type === 'video' ? 'video' : 'image';
            this.trainingDatasetKind = 'source';
            this.trainingDatasetItemsOffset = 0;
            this.trainingDatasetLoaded = false;
            await this.loadTrainingDatasetItems();
            const imageCount = this.trainingDatasetImportedMediaCount('image');
            const videoCount = this.trainingDatasetImportedMediaCount('video');
            this.notice = [
                imageCount ? `사진 ${imageCount}장` : '',
                videoCount ? `동영상 대표 프레임 ${videoCount}장` : '',
            ].filter(Boolean).join(', ')
                + '을 원천 데이터와 AI 검수 대기에 등록했습니다.';
        } else if (!errors.length) {
            this.notice = '새 검수 항목은 없으며 중복 파일만 확인했습니다.';
        }
        if (errors.length) this.errorMessage = errors.join(' / ');
        if (this.trainingDatasetSkippedFileCount) {
            const skipped = `지원하지 않는 파일 ${this.trainingDatasetSkippedFileCount}개는 제외했습니다.`;
            this.notice = this.notice ? this.notice + ' ' + skipped : skipped;
        }
        await this.service.render();
    }

    public trainingDatasetImportedMediaCount(media: 'image' | 'video') {
        return this.trainingDatasetImportedItems.filter(
            item => item?.media_type === media
        ).length;
    }

    public firstTrainingDatasetImportedItem(media: 'image' | 'video') {
        return this.trainingDatasetImportedItems.find(
            item => item?.media_type === media
        ) || null;
    }

    public openTrainingDetectorReview() {
        const media = this.firstTrainingDatasetImportedItem('image')
            ? 'image'
            : 'video';
        const item = this.firstTrainingDatasetImportedItem(media);
        const query = new URLSearchParams({ mode: 'bucky-reaudit', media });
        if (item?.image_id) query.set('review_item', item.image_id);
        this.go('/page.xray/training/label-review?' + query.toString());
    }

    public openTrainingPoseReview(media: 'image' | 'video') {
        const item = this.firstTrainingDatasetImportedItem(media);
        const query = new URLSearchParams({ mode: 'pose', media });
        if (item?.image_id) query.set('review_item', item.image_id);
        this.go('/page.xray/training/normality-review?' + query.toString());
    }

    public async loadTrainingDatasetStatus(quiet = false) {
        try {
            const { code, data } = await wiz.call('training_dataset_status_v1', {});
            if (code === 200) {
                this.reviewedDataset = data?.dataset || this.reviewedDataset;
                if (this.trainingDatasetBuildRunning()) this.startTrainingDatasetPolling();
                else this.stopTrainingDatasetPolling();
            } else if (!quiet) {
                this.errorMessage = data?.message || '검수 데이터셋 현황을 불러오지 못했습니다.';
            }
        } catch (error: any) {
            if (!quiet) this.errorMessage = this.callError(error, '검수 데이터셋 현황을 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public async loadTrainingDatasetItems() {
        const loadGeneration = ++this.trainingDatasetLoadGeneration;
        const requestedMedia = this.trainingDatasetMedia;
        const requestedKind = this.trainingDatasetKind;
        this.trainingDatasetItemsLoading = true;
        this.trainingDatasetThumbnailLoadLimit = 4;
        this.errorMessage = '';
        await this.service.render();
        try {
            const params = new URLSearchParams({
                kind: requestedKind,
                media_type: requestedMedia,
                offset: String(this.trainingDatasetItemsOffset),
                limit: String(this.trainingDatasetItemsLimit),
                decision: this.trainingDatasetDecision,
                query: this.trainingDatasetQuery.trim(),
            });
            const response = await fetch(
                '/wiz/api/page.xray.dataset/list_reviewed_dataset_items_v2?'
                + params.toString(),
                { credentials: 'same-origin' }
            );
            const payload = await response.json();
            const code = Number(payload?.code || response.status || 500);
            const data = payload?.data || {};
            if (loadGeneration !== this.trainingDatasetLoadGeneration) return;
            if (code !== 200) throw new Error(data?.message || '데이터셋 목록을 불러오지 못했습니다.');
            const result = data?.dataset_items || {};
            const responseItems = result?.items || [];
            this.trainingDatasetItems = responseItems.filter(
                (item: any) => item?.media_type === requestedMedia
            );
            this.trainingDatasetItemsTotal = (
                this.trainingDatasetItems.length === responseItems.length
                ? Number(result?.total || 0)
                : this.trainingDatasetItems.length
            );
            this.trainingDatasetLoaded = true;
        } catch (error: any) {
            if (loadGeneration !== this.trainingDatasetLoadGeneration) return;
            this.trainingDatasetItems = [];
            this.trainingDatasetItemsTotal = 0;
            this.errorMessage = this.callError(error, '데이터셋 목록을 불러오지 못했습니다.');
        }
        if (loadGeneration !== this.trainingDatasetLoadGeneration) return;
        this.trainingDatasetItemsLoading = false;
        await this.service.render();
    }

    public async onTrainingDatasetThumbnailSettled(itemIndex: number) {
        if (itemIndex >= this.trainingDatasetThumbnailLoadLimit) return;
        if (this.trainingDatasetThumbnailLoadLimit >= this.trainingDatasetItems.length) return;
        this.trainingDatasetThumbnailLoadLimit += 1;
        await this.service.render();
    }

    public async selectTrainingDatasetView(media: 'image' | 'video', kind: 'source' | 'annotated') {
        if (this.trainingDatasetMedia === media && this.trainingDatasetKind === kind) return;
        this.trainingDatasetMedia = media;
        this.trainingDatasetKind = kind;
        this.trainingDatasetItemsOffset = 0;
        await this.loadTrainingDatasetItems();
    }

    public trainingDatasetViewActive(media: 'image' | 'video', kind: 'source' | 'annotated') {
        return this.trainingDatasetMedia === media && this.trainingDatasetKind === kind;
    }

    public trainingDatasetViewLabel() {
        return `${this.trainingDatasetMedia === 'video' ? '동영상' : '사진'} ${this.trainingDatasetKind === 'source' ? '원천' : '라벨링'}`;
    }

    public trainingDatasetDecisionLabel(item: any) {
        if (item?.decision === 'NORMAL') return '정상';
        if (item?.decision === 'ABNORMAL') return '비정상';
        if (item?.decision === 'DETECTOR_GT') return 'Bucky GT';
        return item?.review_status === 'UNREVIEWED'
            ? '검수 대기'
            : 'Pose 검수';
    }

    public trainingDatasetDecisionClass(item: any) {
        if (item?.decision === 'NORMAL') return 'bg-emerald-100 text-emerald-800';
        if (item?.decision === 'ABNORMAL') return 'bg-red-100 text-red-800';
        if (item?.review_status === 'UNREVIEWED') {
            return 'bg-amber-100 text-amber-800';
        }
        return 'bg-cyan-100 text-cyan-800';
    }

    public async applyTrainingDatasetFilters() {
        this.trainingDatasetItemsOffset = 0;
        await this.loadTrainingDatasetItems();
    }

    public async moveTrainingDatasetPage(direction: number) {
        const next = Math.max(
            0,
            Math.min(
                this.lastTrainingDatasetOffset(),
                this.trainingDatasetItemsOffset + direction * this.trainingDatasetItemsLimit
            )
        );
        if (next === this.trainingDatasetItemsOffset) return;
        this.trainingDatasetItemsOffset = next;
        await this.loadTrainingDatasetItems();
    }

    public trainingDatasetPreviewUrl(item: any) {
        return '/wiz/api/page.xray.dataset_viewer_runtime_v2/thumbnail?image_id='
            + encodeURIComponent(String(item?.image_id || ''))
            + '&kind=' + encodeURIComponent(this.trainingDatasetKind)
            + '&v=' + encodeURIComponent(String(item?.review_revision || 0));
    }

    public async openTrainingDatasetViewer(item: any) {
        if (this.trainingDatasetKind !== 'annotated' || !item?.image_id) return;
        this.trainingDatasetViewerItem = item;
        this.trainingDatasetViewerDetail = null;
        this.trainingDatasetViewerTime = item?.media_type === 'video'
            ? 0
            : Number(item?.video_time_seconds || 0);
        this.trainingDatasetViewerShowPose = true;
        this.trainingDatasetViewerShowDetector = true;
        this.trainingDatasetViewerThumbnailLoaded = false;
        this.trainingDatasetViewerFullImageLoaded = false;
        this.resetTrainingDatasetViewerLiveTracking();
        this.trainingDatasetViewerLoading = true;
        await this.service.render();
        if (item?.media_type === 'video') {
            await this.loadTrainingDatasetViewerDetail(item);
        }
    }

    private async loadTrainingDatasetViewerDetail(item: any) {
        const imageId = String(item?.image_id || '');
        if (!imageId || this.trainingDatasetViewerItem?.image_id !== item?.image_id) return;
        try {
            const params = new URLSearchParams({ image_id: imageId });
            const response = await fetch(
                '/wiz/api/page.xray.dataset_viewer_runtime_v2/detail?'
                + params.toString(),
                { credentials: 'same-origin' }
            );
            const payload = await response.json();
            const code = Number(payload?.code || response.status || 500);
            if (code !== 200) {
                throw new Error(payload?.data?.message || '라벨 상세 정보를 불러오지 못했습니다.');
            }
            if (this.trainingDatasetViewerItem?.image_id !== item?.image_id) return;
            this.trainingDatasetViewerDetail = payload?.data?.detail || null;
        } catch (error: any) {
            if (this.trainingDatasetViewerItem?.image_id !== item?.image_id) return;
            this.errorMessage = this.callError(error, '라벨 상세 정보를 불러오지 못했습니다.');
            this.trainingDatasetViewerItem = null;
        }
        if (this.trainingDatasetViewerItem?.image_id !== item?.image_id) return;
        this.trainingDatasetViewerLoading = false;
        await this.service.render();
    }

    public async onTrainingDatasetViewerThumbnailLoaded() {
        if (this.trainingDatasetViewerThumbnailLoaded) return;
        this.trainingDatasetViewerThumbnailLoaded = true;
        await this.service.render();
        if (this.trainingDatasetViewerItem?.media_type !== 'video') {
            await this.loadTrainingDatasetViewerDetail(this.trainingDatasetViewerItem);
        }
    }

    public async closeTrainingDatasetViewer(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.trainingDatasetViewerItem = null;
        this.trainingDatasetViewerDetail = null;
        this.trainingDatasetViewerLoading = false;
        this.trainingDatasetViewerTime = 0;
        this.trainingDatasetViewerThumbnailLoaded = false;
        this.trainingDatasetViewerFullImageLoaded = false;
        this.resetTrainingDatasetViewerLiveTracking();
        await this.service.render();
    }

    public trainingDatasetViewerSourceUrl() {
        if (!this.trainingDatasetViewerItem?.image_id) return '';
        return '/wiz/api/page.xray.dataset/reviewed_dataset_preview_v2?kind=source&image_id='
            + encodeURIComponent(this.trainingDatasetViewerItem.image_id);
    }

    public trainingDatasetViewerSourceThumbnailUrl() {
        if (!this.trainingDatasetViewerItem?.image_id) return '';
        return '/wiz/api/page.xray.dataset_viewer_runtime_v2/thumbnail?kind=source&image_id='
            + encodeURIComponent(this.trainingDatasetViewerItem.image_id)
            + '&v=' + encodeURIComponent(String(
                this.trainingDatasetViewerItem?.review_revision || 0
            ));
    }

    public trainingDatasetViewerVideoUrl() {
        if (!this.trainingDatasetViewerItem?.image_id) return '';
        return '/wiz/api/page.xray.dataset_viewer_runtime_v2/video?image_id='
            + encodeURIComponent(this.trainingDatasetViewerItem.image_id);
    }

    public updateTrainingDatasetViewerTime(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.trainingDatasetViewerTime = Number(
            video?.currentTime || 0
        );
        this.service.render();
        void this.captureTrainingDatasetViewerLiveFrame(video);
    }

    private resetTrainingDatasetViewerLiveTracking() {
        this.trainingDatasetViewerLiveGeneration += 1;
        this.trainingDatasetViewerLivePosePoints = [];
        this.trainingDatasetViewerLiveDetectorPolygon = null;
        this.trainingDatasetViewerLiveSourceTime = -1;
        this.trainingDatasetViewerLiveBusy = false;
        this.trainingDatasetViewerLiveError = '';
        this.trainingDatasetViewerLiveLastRequestedAt = 0;
        this.trainingDatasetViewerLiveTrackingId = (
            (window.crypto as any)?.randomUUID?.()
            || `training-dataset-viewer-${Date.now()}-${Math.random().toString(16).slice(2)}`
        );
    }

    private async captureTrainingDatasetViewerLiveFrame(video: HTMLVideoElement) {
        if (!video || video.readyState < 2 || !video.videoWidth || this.trainingDatasetViewerLiveBusy) return;
        const now = performance.now();
        if (!video.paused && now - this.trainingDatasetViewerLiveLastRequestedAt < 320) return;
        const generation = this.trainingDatasetViewerLiveGeneration;
        const sourceTime = Number(video.currentTime || 0);
        this.trainingDatasetViewerLiveLastRequestedAt = now;
        this.trainingDatasetViewerLiveBusy = true;
        try {
            const canvas = document.createElement('canvas');
            const scale = Math.min(1, 640 / video.videoWidth);
            canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
            canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
            const context = canvas.getContext('2d');
            if (!context) return;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(
                resolve, 'image/jpeg', .78
            ));
            if (!blob || generation !== this.trainingDatasetViewerLiveGeneration) return;
            const form = new FormData();
            form.append('image', blob, 'training-dataset-video-frame.jpg');
            form.append('realtime', '1');
            form.append('analysis_backend', 'yolo_candidate');
            form.append('tracking_id', this.trainingDatasetViewerLiveTrackingId);
            const response = await fetch('/wiz/api/page.xray/analyze_v2', {
                method: 'POST', body: form, credentials: 'same-origin',
            });
            const payload = await response.json();
            if (generation !== this.trainingDatasetViewerLiveGeneration) return;
            const data = payload?.data || {};
            const landmarks = Array.isArray(data?.landmarks) ? data.landmarks : [];
            if (landmarks.length) {
                this.trainingDatasetViewerLivePosePoints = landmarks.map((point: any, index: number) => ({
                    id: Number(point?.id ?? index),
                    x: Number(point?.x), y: Number(point?.y),
                    confidence: Number(point?.confidence ?? point?.visibility ?? 0),
                    visibility: Number(point?.confidence ?? point?.visibility ?? 0) >= .2
                        ? 'visible' : 'not_labeled',
                }));
            }
            const detector = data?.bucky_detection || data?.bucky || {};
            const corners = detector?.corners || detector?.detector_config?.corners || null;
            this.trainingDatasetViewerLiveDetectorPolygon = corners || null;
            this.trainingDatasetViewerLiveSourceTime = sourceTime;
            this.trainingDatasetViewerLiveError = landmarks.length
                ? '' : '현재 프레임에서 자세 모델 좌표를 찾지 못했습니다.';
        } catch (_error) {
            if (generation === this.trainingDatasetViewerLiveGeneration) {
                this.trainingDatasetViewerLiveError = '현재 프레임 모델 추적을 다시 시도하고 있습니다.';
            }
        } finally {
            if (generation === this.trainingDatasetViewerLiveGeneration) {
                this.trainingDatasetViewerLiveBusy = false;
                await this.service.render();
            }
        }
    }

    private trainingDatasetViewerLabelSegment(labels: any[]) {
        if (!labels?.length) return null;
        const sorted = [...labels].sort(
            (left: any, right: any) => Number(left?.time_seconds || 0) - Number(right?.time_seconds || 0)
        );
        const before = [...sorted].reverse().find(
            (item: any) => Number(item?.time_seconds || 0) <= this.trainingDatasetViewerTime
        ) || sorted[0];
        const after = sorted.find(
            (item: any) => Number(item?.time_seconds || 0) >= this.trainingDatasetViewerTime
        ) || sorted[sorted.length - 1];
        const beforeTime = Number(before?.time_seconds || 0);
        const afterTime = Number(after?.time_seconds || 0);
        const ratio = afterTime > beforeTime
            ? Math.max(0, Math.min(1, (this.trainingDatasetViewerTime - beforeTime) / (afterTime - beforeTime)))
            : 0;
        return { before, after, ratio };
    }

    private trainingDatasetViewerInterpolatedPoseField(field: string) {
        const segment = this.trainingDatasetViewerLabelSegment(
            this.trainingDatasetViewerDetail?.pose_labels || []
        );
        if (!segment) return [];
        const before = new Map<number, any>(
            (segment.before?.[field] || []).map((point: any) => [Number(point.id), point])
        );
        const after = new Map<number, any>(
            (segment.after?.[field] || []).map((point: any) => [Number(point.id), point])
        );
        return Array.from(new Set([...before.keys(), ...after.keys()])).map(id => {
            const first = before.get(id) || after.get(id);
            const second = after.get(id) || before.get(id);
            return {
                ...first,
                id,
                x: Number(first?.x || 0) + (Number(second?.x || 0) - Number(first?.x || 0)) * segment.ratio,
                y: Number(first?.y || 0) + (Number(second?.y || 0) - Number(first?.y || 0)) * segment.ratio,
                visibility: first?.visibility === 'not_labeled' && second?.visibility === 'not_labeled'
                    ? 'not_labeled'
                    : 'visible',
            };
        });
    }

    private trainingDatasetViewerInterpolatedDetectorPolygon(field = 'detector_polygon') {
        const segment = this.trainingDatasetViewerLabelSegment(
            this.trainingDatasetViewerDetail?.detector_labels || []
        );
        if (!segment) return {};
        const polygon: any = {};
        for (const key of ['top_left', 'top_right', 'bottom_right', 'bottom_left']) {
            const first = segment.before?.[field]?.[key]
                || segment.after?.[field]?.[key];
            const second = segment.after?.[field]?.[key]
                || segment.before?.[field]?.[key];
            if (!first || !second) continue;
            polygon[key] = {
                x: Number(first.x || 0) + (Number(second.x || 0) - Number(first.x || 0)) * segment.ratio,
                y: Number(first.y || 0) + (Number(second.y || 0) - Number(first.y || 0)) * segment.ratio,
            };
        }
        return polygon;
    }

    private trainingDatasetViewerTrackedPosePoints() {
        const saved = this.trainingDatasetViewerInterpolatedPoseField('pose_keypoints');
        if (
            !this.trainingDatasetViewerLivePosePoints.length
            || Math.abs(this.trainingDatasetViewerLiveSourceTime - this.trainingDatasetViewerTime) > .75
        ) return saved;
        const reference = new Map<number, any>(
            this.trainingDatasetViewerInterpolatedPoseField('pose_reference_keypoints')
                .map((point: any) => [Number(point.id), point])
        );
        const corrected = new Map<number, any>(
            saved.map((point: any) => [Number(point.id), point])
        );
        return this.trainingDatasetViewerLivePosePoints.map((point: any) => {
            const base = reference.get(Number(point.id));
            const target = corrected.get(Number(point.id));
            if (!base || !target) return point;
            return {
                ...point,
                x: Math.max(0, Math.min(1, Number(point.x) + Number(target.x) - Number(base.x))),
                y: Math.max(0, Math.min(1, Number(point.y) + Number(target.y) - Number(base.y))),
            };
        });
    }

    private trainingDatasetViewerTrackedDetectorPolygon() {
        const saved = this.trainingDatasetViewerInterpolatedDetectorPolygon();
        const livePoseFresh = this.trainingDatasetViewerLivePosePoints.length
            && Math.abs(this.trainingDatasetViewerLiveSourceTime - this.trainingDatasetViewerTime) <= .75;
        if (
            !this.trainingDatasetViewerLiveDetectorPolygon
            || Math.abs(this.trainingDatasetViewerLiveSourceTime - this.trainingDatasetViewerTime) > .75
        ) {
            if (!livePoseFresh || Object.keys(saved).length !== 4) return saved;
            const referencePoints = new Map<number, any>(
                this.trainingDatasetViewerInterpolatedPoseField('pose_reference_keypoints')
                    .map((point: any) => [Number(point.id), point])
            );
            const livePoints = new Map<number, any>(
                this.trainingDatasetViewerLivePosePoints.map((point: any) => [Number(point.id), point])
            );
            const ids = [11, 12].filter(id => referencePoints.has(id) && livePoints.has(id));
            if (!ids.length) return saved;
            const dx = ids.reduce((sum, id) => (
                sum + Number(livePoints.get(id).x) - Number(referencePoints.get(id).x)
            ), 0) / ids.length;
            const dy = ids.reduce((sum, id) => (
                sum + Number(livePoints.get(id).y) - Number(referencePoints.get(id).y)
            ), 0) / ids.length;
            return Object.fromEntries(Object.entries(saved).map(([key, point]: [string, any]) => [
                key,
                {
                    x: Math.max(0, Math.min(1, Number(point.x) + dx)),
                    y: Math.max(0, Math.min(1, Number(point.y) + dy)),
                },
            ]));
        }
        const reference = this.trainingDatasetViewerInterpolatedDetectorPolygon(
            'raw_detector_polygon'
        );
        const tracked: any = {};
        for (const key of ['top_left', 'top_right', 'bottom_right', 'bottom_left']) {
            const live = this.trainingDatasetViewerLiveDetectorPolygon?.[key];
            if (!live) continue;
            tracked[key] = reference?.[key] && saved?.[key]
                ? {
                    x: Math.max(0, Math.min(1, Number(live.x) + Number(saved[key].x) - Number(reference[key].x))),
                    y: Math.max(0, Math.min(1, Number(live.y) + Number(saved[key].y) - Number(reference[key].y))),
                }
                : live;
        }
        return Object.keys(tracked).length === 4 ? tracked : saved;
    }

    public trainingDatasetViewerPosePoints() {
        const points = this.trainingDatasetViewerTrackedPosePoints();
        return points.filter((point: any) => (
            POSE_TEST_VISIBLE_IDS.has(Number(point?.id))
            &&
            point?.visibility !== 'not_labeled'
            && Number.isFinite(Number(point?.x))
            && Number.isFinite(Number(point?.y))
        ));
    }

    public trainingDatasetViewerPoseEdges() {
        const points = new Map<number, any>(
            this.trainingDatasetViewerPosePoints().map(
                (point: any) => [Number(point.id), point]
            )
        );
        return POSE_TEST_EDGES.map(([from, to]) => ({
            from: points.get(from), to: points.get(to), key: `${from}-${to}`,
        })).filter(edge => edge.from && edge.to);
    }

    public trainingDatasetViewerDetectorPoints() {
        const polygon = this.trainingDatasetViewerTrackedDetectorPolygon();
        return ['top_left', 'top_right', 'bottom_right', 'bottom_left']
            .map(key => polygon?.[key])
            .filter(Boolean)
            .map(point => `${Number(point.x || 0) * 1000},${Number(point.y || 0) * 1000}`)
            .join(' ');
    }

    public trainingDatasetPageNumber() {
        return Math.floor(this.trainingDatasetItemsOffset / this.trainingDatasetItemsLimit) + 1;
    }

    public trainingDatasetPageCount() {
        return Math.max(1, Math.ceil(this.trainingDatasetItemsTotal / this.trainingDatasetItemsLimit));
    }

    private lastTrainingDatasetOffset() {
        return Math.max(0, (this.trainingDatasetPageCount() - 1) * this.trainingDatasetItemsLimit);
    }

    public trainingDatasetBuildRunning() {
        return ['queued', 'running'].includes(String(this.reviewedDataset?.job?.status || ''));
    }

    public poseTrainingMediaLabel(mode: 'image' | 'video' | 'all' = this.poseTrainingMediaMode) {
        return ({ image: '사진만', video: '동영상만', all: '사진+동영상' } as any)[mode];
    }

    public detectorTrainingMediaLabel(scope: string = 'all') {
        return ({ photo: '사진만', video: '동영상만', all: '사진+동영상' } as any)[scope] || '사진+동영상';
    }

    public detectorRegressionGateValue(gate: any, role: 'candidate' | 'baseline') {
        const value = gate?.[role];
        if (gate?.format === 'percent') return this.percentMetric(value);
        if (gate?.format === 'count') return Number(value || 0) + '건';
        return this.evaluationValue(value, 4);
    }

    public hardNegativeCropDirectionLabel(direction: string) {
        return ({ top: '촬영판 위쪽 영역', bottom: '촬영판 아래쪽 영역' } as any)[direction]
            || '촬영판이 없는 영역';
    }

    public trainingVideoReviewCount() {
        return Number(
            this.reviewedDataset?.inventory_counts?.video_source
            || this.normalityReview()?.fresh_video_count
            || 0
        );
    }

    public trainingImageReviewCount() {
        return Number(this.reviewedDataset?.inventory_counts?.image_source || 0);
    }

    public detectorImageReviewRemainingCount(): number | null {
        const inventory = this.reviewedDataset?.inventory_counts || {};
        const explicit = inventory?.image_detector_reviewed;
        const summary = this.pilotSummary?.reviewed_detector_label_count;
        const reviewed = explicit !== undefined && explicit !== null
            ? Number(explicit)
            : summary !== undefined && summary !== null
                ? Number(summary)
                : null;
        if (reviewed === null) return null;
        return Math.max(0, this.trainingImageReviewCount() - reviewed);
    }

    public detectorImageReviewButtonLabel() {
        const remaining = this.detectorImageReviewRemainingCount();
        return remaining === null
            ? '사진 검수 (남은 수량 집계 중)'
            : `사진 검수 (${remaining}장 남음)`;
    }

    public detectorVideoReviewRemainingCount() {
        const reviewed = Number(
            this.reviewedDataset?.inventory_counts?.video_detector_reviewed
            || 0
        );
        return Math.max(0, this.trainingVideoReviewCount() - reviewed);
    }

    public poseImageReviewRemainingCount(): number | null {
        const directRemaining = this.normalityReview()?.pose_unreviewed_image_count;
        if (directRemaining !== undefined && directRemaining !== null) {
            return Math.max(0, Number(directRemaining));
        }
        const inventory = this.reviewedDataset?.inventory_counts || {};
        const explicit = inventory?.image_pose_reviewed;
        const summaryAvailable = Boolean(this.capabilities?.normality_review);
        const reviewed = explicit !== undefined && explicit !== null
            ? Number(explicit)
            : summaryAvailable
                ? this.poseReviewedImageCount()
                : null;
        if (reviewed === null) return null;
        return Math.max(0, this.trainingImageReviewCount() - reviewed);
    }

    public poseImageReviewButtonLabel() {
        const remaining = this.poseImageReviewRemainingCount();
        return remaining === null
            ? '사진 검수 (남은 수량 집계 중)'
            : `사진 검수 (${remaining}장 남음)`;
    }

    public poseVideoReviewRemainingCount() {
        const reviewed = Number(
            this.reviewedDataset?.inventory_counts?.video_pose_reviewed
            || 0
        );
        return Math.max(0, this.trainingVideoReviewCount() - reviewed);
    }

    public poseReviewedVideoCount() {
        return Number(
            this.normalityReview()?.pose_reviewed_video_count
            ?? this.normalityReview()?.pose_reviewed_video_frame_count
            ?? 0
        );
    }

    public poseReviewedImageCount() {
        return Math.max(0, Number(this.normalityReview()?.pose_reviewed || 0) - this.poseReviewedVideoCount());
    }

    public poseTrainingMediaCount(mode: 'image' | 'video' | 'all' = this.poseTrainingMediaMode) {
        if (mode === 'image') return this.poseReviewedImageCount();
        if (mode === 'video') return this.poseReviewedVideoCount();
        return this.poseReviewedImageCount() + this.poseReviewedVideoCount();
    }

    public canPreparePoseTraining(mode: 'image' | 'video' | 'all') {
        return this.poseTrainingMediaCount(mode) > 0
            && !this.hasActiveTrainingJob();
    }

    public poseTrainingReady() {
        return Boolean(this.profile('yolo_pose_retry')?.available)
            && Boolean(this.operatingPoseModel())
            && ['image', 'video', 'all'].some(
                mode => this.canPreparePoseTraining(mode as 'image' | 'video' | 'all')
            );
    }

    public async preparePoseTraining(mode: 'image' | 'video' | 'all') {
        if (!this.canPreparePoseTraining(mode)) return;
        this.poseTrainingMediaMode = mode;
        this.poseTrainingPrepared = true;
        this.errorMessage = '';
        this.notice = `${this.poseTrainingMediaLabel()} Pose 검수 ${this.poseTrainingMediaCount()}장을 학습 자료로 선택했습니다. 학습 시작 시 현재 검수 좌표를 고정합니다.`;
        await this.service.render();
    }

    public async refreshPoseInventory() {
        if (this.actionBusy || this.hasActiveTrainingJob()) return;
        this.actionBusy = true;
        this.poseTrainingPrepared = false;
        await this.loadState(true);
        if (!this.errorMessage) {
            this.notice = `Pose 검수 자료를 다시 읽었습니다. 사진 ${this.poseReviewedImageCount()}장 · 동영상 ${this.poseReviewedVideoCount()}장입니다.`;
        }
        this.actionBusy = false;
        await this.service.render();
    }

    public goPoseReview() {
        const media = this.poseTrainingMediaMode === 'video' ? 'video' : 'image';
        this.go(`/page.xray/training/normality-review?mode=pose&media=${media}`);
    }

    public async buildTrainingDatasetZip(mediaMode: 'image' | 'video' | 'all' = this.poseTrainingMediaMode) {
        if (this.trainingDatasetBuildBusy || this.trainingDatasetBuildRunning()) return;
        this.poseTrainingMediaMode = mediaMode;
        this.trainingDatasetBuildBusy = true;
        this.notice = '';
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('training_dataset_build_v1', {});
            if (code === 200 || code === 202) {
                this.reviewedDataset = data?.dataset || this.reviewedDataset;
                const prefix = `${this.poseTrainingMediaLabel()} 학습 준비: `;
                this.notice = prefix + (this.reviewedDataset?.message || '검수 데이터셋 ZIP 생성을 시작했습니다.');
                if (this.trainingDatasetBuildRunning()) this.startTrainingDatasetPolling();
            } else this.errorMessage = data?.message || '검수 데이터셋 ZIP 생성을 시작하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '검수 데이터셋 ZIP 생성을 시작하지 못했습니다.');
        }
        this.trainingDatasetBuildBusy = false;
        await this.service.render();
    }

    public downloadTrainingDatasetZip() {
        if (!this.reviewedDataset?.artifact?.available || this.trainingDatasetBuildRunning()) return;
        window.location.href = '/wiz/api/page.xray.experiments/training_dataset_download_v1';
    }

    public trainingDatasetFormatBytes(value: any) {
        const bytes = Number(value || 0);
        if (!bytes) return '-';
        if (bytes >= 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024 / 1024).toFixed(1)} GB`;
        if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
        return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    }

    private startTrainingDatasetPolling() {
        if (this.trainingDatasetPollTimer) return;
        this.trainingDatasetPollTimer = setInterval(() => this.loadTrainingDatasetStatus(true), 1500);
    }

    private stopTrainingDatasetPolling() {
        if (this.trainingDatasetPollTimer) clearInterval(this.trainingDatasetPollTimer);
        this.trainingDatasetPollTimer = null;
    }

    private async freshTrainingCall(action: string, payload: any = {}) {
        const form = payload instanceof FormData ? payload : new FormData();
        if (!(payload instanceof FormData)) {
            for (const [key, value] of Object.entries(payload || {})) {
                form.append(key, value == null ? '' : String(value));
            }
        }
        if (action) form.append('training_action', action);
        const endpoint = action ? this.freshTrainingActionApi : this.freshTrainingStateApi;
        const response = await fetch(endpoint, {
            method: 'POST', body: form, credentials: 'same-origin',
        });
        const result = await response.json();
        return result || { code: response.status, data: {} };
    }

    private async judgementCandidateCall(action: string, payload: any = {}) {
        const form = payload instanceof FormData ? payload : new FormData();
        if (!(payload instanceof FormData)) {
            for (const [key, value] of Object.entries(payload || {})) {
                form.append(key, value == null ? '' : String(value));
            }
        }
        if (action) form.append('training_action', action);
        const response = await fetch(this.judgementCandidateActionApi, {
            method: 'POST', body: form, credentials: 'same-origin',
        });
        const result = await response.json();
        return result || { code: response.status, data: {} };
    }

    private trainingCall(action: string, payload: any = {}, options: any = {}) {
        if (['', 'experiment_save', 'experiment_start', 'reviewed_pose_training_start', 'reviewed_zip_pose_training_start', 'job_cancel', 'job_status', 'metrics', 'artifacts', 'legacy_compare', 'pose_weights_status', 'pose_weights_import'].includes(action)) {
            return this.freshTrainingCall(action, payload);
        }
        if (payload instanceof FormData) {
            if (action) payload.append('training_action', action);
            return wiz.call('load_paper_state_v2', payload, options);
        }
        const body = action ? { ...(payload || {}), training_action: action } : (payload || {});
        return wiz.call('load_paper_state_v2', body, options);
    }

    public async loadState(quiet = false) {
        if (this.loading && !quiet) return;
        if (!quiet) this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await this.trainingCall('');
            if (code === 200) {
                this.summary = data?.summary || this.emptySummary();
                this.readiness = data?.readiness || this.readiness;
                this.capabilities = data?.capabilities || this.capabilities;
                this.poseModels = this.capabilities?.pose_models || this.poseModels;
                this.reviewedDataset = data?.reviewed_dataset || this.reviewedDataset;
                const availablePoseModels = this.poseModelOptions().map((item: any) => item.key);
                if (!availablePoseModels.includes(this.configuration.pose_model)) {
                    this.configuration.pose_model = this.poseModels?.default_model || 'yolo26s-pose';
                }
                this.experiments = data?.experiments || [];
                this.jobs = data?.jobs || [];
                this.candidateModels = data?.candidate_models || [];
                this.activeModel = data?.active_model || null;
                this.yoloPromotion = data?.yolo_promotion || this.yoloPromotion;
                this.metadata = data?.metadata || this.metadata;
                this.metadataRecords = data?.metadata_records || [];
                this.restoreSelection();
            } else this.errorMessage = data?.message || '학습 현황을 불러오지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '학습 현황을 불러오지 못했습니다.');
        }
        this.loading = false;
        await this.service.render();
    }

    public async loadBatchSummary(quiet = false) {
        try {
            // Direct versioned callable prevents a long-lived WIZ API/model
            // cache from dropping live_review and showing PASS audit as 0 / 0.
            const { code, data } = await wiz.call('batch_analysis_summary_v6', {});
            if (code === 200) {
                this.batchSummary = data?.summary || this.batchSummary;
                this.batchJob = this.batchSummary?.latest_job || this.batchJob;
                if (['queued', 'running'].includes(this.batchJob?.status)) this.startBatchPolling();
            } else if (!quiet) this.errorMessage = data?.message || '일괄 분석 현황을 불러오지 못했습니다.';
        } catch (error: any) {
            if (!quiet) this.errorMessage = this.callError(error, '일괄 분석 현황을 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public async loadPilotSummary(quiet = false) {
        this.pilotSummaryError = '';
        try {
            const { code, data } = await wiz.call('pilot_retraining_summary_v9', {});
            if (code === 200 && data?.summary) {
                this.pilotSummary = data.summary;
                this.detectorTrainingJob = data.summary?.detector_training_job || this.detectorTrainingJob;
                this.serverTrainingResources = data.summary?.server_training_resources || this.serverTrainingResources;
                this.detectorCandidateModels = data.summary?.detector_candidate_models || [];
                if (!this.detectorCandidateModels.some((model: any) => model?.weight_sha256 === this.detectorEvaluationModelSha)) {
                    this.detectorEvaluationModelSha = String(this.detectorCandidateModels?.[0]?.weight_sha256 || '');
                }
                const testableDetectorModels = this.detectorTestableCandidateModels();
                if (!testableDetectorModels.some((model: any) => model?.weight_sha256 === this.detectorCandidateTestModelSha)) {
                    this.detectorCandidateTestModelSha = String(testableDetectorModels?.[0]?.weight_sha256 || '');
                }
                this.pilotSummaryLoaded = true;
            } else {
                this.pilotSummaryLoaded = false;
                this.pilotSummaryError = data?.message || '공용파일 현황 API가 아직 준비되지 않았습니다.';
                if (!quiet) this.errorMessage = this.pilotSummaryError;
            }
        } catch (error: any) {
            this.pilotSummaryLoaded = false;
            this.pilotSummaryError = this.callError(error, '공용파일 포함 보정 학습 현황을 불러오지 못했습니다.');
            if (!quiet) this.errorMessage = this.pilotSummaryError;
        }
        await this.service.render();
    }

    public combinedTrainingTotal() {
        return Number(this.pilotSummary?.combined_total || this.summary?.total || 0);
    }

    public scrollToDetectorEvaluationResults() {
        document.getElementById('detector-training-results')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    public publicReviewRemaining() {
        return Math.max(0, Number(this.pilotSummary?.public_review_remaining_count || 0));
    }

    public publicPredictionPending() {
        return Math.max(0, Number(this.pilotSummary?.public_prediction_pending_count || 0));
    }

    public goPublicDetectorReview(media: 'image' | 'video' = 'image') {
        const query = new URLSearchParams({
            mode: 'bucky-reaudit',
            media,
        });
        this.go('/page.xray/training/label-review?' + query.toString());
    }

    public async prepareDetectorFineTuning() {
        if (!this.pilotSummary?.detector_training_ready || this.actionBusy || this.detectorTrainingRunning()) return;
        this.actionBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('prepare_detector_finetuning_v10', {});
            if (code === 200) {
                this.detectorPreparation = data?.prepared || null;
                this.notice = 'Bucky 디텍터 candidate 데이터와 실행 명령을 준비했습니다. 실제 학습과 운영 모델 교체는 시작하지 않았습니다.';
            } else this.errorMessage = data?.message || '디텍터 candidate 데이터를 준비하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '디텍터 candidate 데이터를 준비하지 못했습니다.');
        }
        this.actionBusy = false;
        await this.loadPilotSummary(true);
    }

    public async prepareDetectorPhotoFineTuning() {
        if (!this.pilotSummary?.detector_training_ready || this.actionBusy || this.detectorTrainingRunning()) return;
        this.actionBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('prepare_detector_finetuning_v10', {
                media_scope: 'photo',
            });
            if (code === 200) {
                this.detectorPreparation = data?.prepared || null;
                this.notice = '사진 검수 결과만 Candidate 학습 데이터로 준비했습니다. 기존 동영상 GT 15건은 제외했으며 실제 학습과 운영 모델 교체는 시작하지 않았습니다.';
            } else this.errorMessage = data?.message || '사진 전용 디텍터 candidate 데이터를 준비하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '사진 전용 디텍터 candidate 데이터를 준비하지 못했습니다.');
        }
        this.actionBusy = false;
        await this.loadPilotSummary(true);
    }

    public async prepareDetectorVideoFineTuning() {
        if (!this.pilotSummary?.detector_video_training_ready || this.actionBusy || this.detectorTrainingRunning()) return;
        this.actionBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('prepare_detector_finetuning_v10', {
                media_scope: 'video',
            });
            if (code === 200) {
                this.detectorPreparation = data?.prepared || null;
                this.notice = '검수 완료 동영상 GT만 Candidate 학습 train으로 준비했습니다. 사진은 고정 val/test 평가에만 유지되며 실제 학습과 운영 모델 교체는 시작하지 않았습니다.';
            } else this.errorMessage = data?.message || '동영상 전용 디텍터 candidate 데이터를 준비하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '동영상 전용 디텍터 candidate 데이터를 준비하지 못했습니다.');
        }
        this.actionBusy = false;
        await this.loadPilotSummary(true);
    }

    public detectorPrepareBlockReason() {
        if (!this.pilotSummaryLoaded) return this.pilotSummaryError || '디텍터 학습 현황을 불러오는 중입니다.';
        if (this.detectorTrainingRunning()) return '현재 Candidate 학습이 진행 중입니다. 완료 후 새 학습 데이터를 준비할 수 있습니다.';
        if (this.publicPredictionPending()) return `공용 원본 ${this.publicPredictionPending()}장을 자동 예측해 검수 큐에 먼저 등록해 주세요.`;
        if (!this.pilotSummary?.all_public_files_in_queue) return '공용 원본 전체가 디텍터 검수 큐에 포함되어야 합니다.';
        if (Number(this.pilotSummary?.public_detector_positive_count || 0) < 30) return '실제 장비 최외곽으로 확정한 Bucky GT가 30장 이상 필요합니다.';
        if (Number(this.pilotSummary?.group_leakage_count || 0)) return 'Train/Validation/Test 사이 유사 이미지 그룹 누수를 먼저 제거해 주세요.';
        if (this.pilotSummary?.fixed_test_modified) return '고정 회귀 test가 변경되어 candidate 준비가 차단되었습니다.';
        return '';
    }

    public detectorPreparationMessage() {
        const scope = String(this.detectorTrainingJob?.media_scope || 'all');
        if (scope === 'photo') return '사진 전용 Candidate 학습 준비가 완료되었습니다. 동영상 GT는 포함되지 않았습니다.';
        if (scope === 'video') return '동영상 전용 Candidate 학습 준비가 완료되었습니다. 사진은 고정 val/test 평가에만 유지됩니다.';
        return '사진+동영상 Candidate 학습 준비가 완료되었습니다.';
    }

    public detectorPreparationCommand() {
        const commands = this.detectorPreparation?.commands || [];
        return commands.length ? String(commands[0]) : '';
    }

    public detectorPreparationOutput() {
        return String(this.detectorPreparation?.output || '');
    }

    public detectorTrainingRunning() {
        return ['queued', 'running'].includes(this.detectorTrainingJob?.status);
    }

    public detectorTrainingCanStart() {
        return this.detectorTrainingJob?.status === 'prepared'
            && this.serverTrainingResources?.start_allowed === true
            && !this.detectorTrainingBusy;
    }

    public serverTrainingResourceClass() {
        if (this.serverTrainingResources?.status === 'stop_recommended') {
            return 'border-red-300 bg-red-50 text-red-900';
        }
        if (this.serverTrainingResources?.status === 'wait') {
            return 'border-amber-300 bg-amber-50 text-amber-900';
        }
        if (this.serverTrainingResources?.status === 'available') {
            return 'border-emerald-300 bg-emerald-50 text-emerald-900';
        }
        return 'border-slate-300 bg-slate-50 text-slate-700';
    }

    public detectorTrainingProgress() {
        const current = Math.max(0, Number(this.detectorTrainingJob?.current_epoch || 0));
        const total = Math.max(1, Number(this.detectorTrainingJob?.total_epochs || 80));
        return Math.min(100, Math.round(current / total * 100));
    }

    public detectorTrainingButtonLabel() {
        if (this.detectorTrainingJob?.status === 'completed') return '학습 완료';
        if (this.detectorTrainingJob?.status === 'failed') return '다시 준비 필요';
        if (this.detectorTrainingJob?.status === 'cancelled') return '다시 준비 필요';
        if (this.detectorTrainingRunning()) {
            return `학습 중 ${this.detectorTrainingJob?.current_epoch || 0}/${this.detectorTrainingJob?.total_epochs || 80}`;
        }
        return '학습하기';
    }

    public async startDetectorTraining() {
        if (!this.detectorTrainingCanStart()) return;
        this.detectorTrainingBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('start_detector_training_v11', {});
            if (![200, 202].includes(code)) throw new Error(data?.message || 'Bucky Candidate 학습을 시작하지 못했습니다.');
            this.detectorTrainingJob = data?.job || this.detectorTrainingJob;
            this.notice = 'Bucky Candidate 학습을 시작했습니다. 운영 모델은 변경하지 않습니다.';
            if (this.detectorTrainingRunning()) this.startDetectorTrainingPolling();
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Bucky Candidate 학습을 시작하지 못했습니다.');
        }
        this.detectorTrainingBusy = false;
        await this.service.render();
    }

    public async stopDetectorTraining() {
        if (!this.detectorTrainingRunning() || this.detectorTrainingStopping) return;
        if (!window.confirm('진행 중인 Candidate 학습을 중지할까요? 현재 Epoch 진행 내용은 폐기되며 새 학습 준비가 필요합니다.')) return;
        this.detectorTrainingStopping = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('start_detector_training_v11', {
                training_action: 'stop',
            });
            if (code !== 200) throw new Error(data?.message || 'Bucky Candidate 학습을 중지하지 못했습니다.');
            this.detectorTrainingJob = data?.job || this.detectorTrainingJob;
            this.stopDetectorTrainingPolling();
            this.notice = data?.stopped
                ? 'Bucky Candidate 학습을 중지했습니다. 새 Candidate 학습 준비를 실행해 주세요.'
                : '이미 종료된 Candidate 학습입니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Bucky Candidate 학습을 중지하지 못했습니다.');
        }
        this.detectorTrainingStopping = false;
        await this.loadPilotSummary(true);
        await this.service.render();
    }

    public async pollDetectorTraining() {
        try {
            const { code, data } = await wiz.call('detector_training_status_v11', {});
            if (code !== 200) throw new Error(data?.message || 'Bucky Candidate 학습 현황을 불러오지 못했습니다.');
            const previous = this.detectorTrainingJob?.status;
            this.detectorTrainingJob = data?.job || { status: 'idle' };
            this.serverTrainingResources = data?.server_resources || this.serverTrainingResources;
            if (!this.detectorTrainingRunning()) {
                this.stopDetectorTrainingPolling();
                if (this.detectorTrainingJob?.status === 'completed' && previous !== 'completed') {
                    this.notice = this.detectorTrainingJob?.regression_passed
                        ? 'Bucky Candidate 학습과 고정 회귀 평가를 완료했습니다.'
                        : '학습은 완료됐지만 고정 회귀 평가를 통과하지 못했습니다.';
                    await this.loadPilotSummary(true);
                } else if (this.detectorTrainingJob?.status === 'failed') {
                    this.errorMessage = this.detectorTrainingJob?.error || 'Bucky Candidate 학습이 실패했습니다.';
                } else if (this.detectorTrainingJob?.status === 'cancelled') {
                    this.notice = 'Bucky Candidate 학습이 중지되었습니다. 새 학습 준비를 실행해 주세요.';
                }
            }
        } catch (error: any) {
            this.stopDetectorTrainingPolling();
            this.errorMessage = this.callError(error, 'Bucky Candidate 학습 현황을 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    private startDetectorTrainingPolling() {
        if (this.detectorTrainingPollTimer) return;
        this.detectorTrainingPollTimer = setInterval(() => this.pollDetectorTraining(), 3000);
    }

    private stopDetectorTrainingPolling() {
        if (this.detectorTrainingPollTimer) clearInterval(this.detectorTrainingPollTimer);
        this.detectorTrainingPollTimer = null;
    }

    public selectedDetectorEvaluationModel() {
        return this.detectorCandidateModels.find(
            (model: any) => model?.weight_sha256 === this.detectorEvaluationModelSha
        ) || null;
    }

    public detectorTestableCandidateModels() {
        return this.detectorCandidateModels.filter(
            (model: any) => model?.regression_passed === true
        );
    }

    public async selectDetectorEvaluationModel(model: any) {
        this.detectorEvaluationModelSha = String(model?.weight_sha256 || '');
        await this.service.render();
    }

    public async onDetectorCandidateTestVideo(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0] || null;
        this.clearDetectorCandidateTestVideo();
        this.detectorCandidateTestFile = file;
        this.detectorCandidateTestResult = null;
        this.detectorCandidateTestPassed = false;
        this.detectorCandidateTestFrame = null;
        this.detectorCandidateTestGtMode = false;
        this.resetDetectorCandidateGt();
        this.detectorCandidateTestFailureSaved = null;
        this.detectorCandidateMovementPhase = 'moving';
        if (file) this.detectorCandidateTestVideoUrl = URL.createObjectURL(file);
        await this.service.render();
    }

    public async onDetectorCandidateTestModelChange() {
        this.stopDetectorCandidateRealtime();
        this.detectorCandidateTestResult = null;
        this.detectorCandidateTestFrame = null;
        this.detectorCandidateTestPassed = false;
        this.detectorCandidateTestFailureSaved = null;
        this.detectorCandidateTestGtMode = false;
        this.resetDetectorCandidateGt();
        await this.service.render();
    }

    public async toggleDetectorCandidateRealtime() {
        if (this.detectorCandidateRealtimeOn) {
            this.stopDetectorCandidateRealtime();
            return;
        }
        if (!this.detectorCandidateTestModelSha) {
            this.detectorCandidateRealtimeError = '먼저 업그레이드 모델을 선택해 주세요.';
            await this.service.render();
            return;
        }
        if (!this.detectorCandidateTestFile || !this.detectorCandidateTestVideoUrl) {
            this.detectorCandidateRealtimeError = '먼저 테스트할 동영상을 선택해 주세요.';
            await this.service.render();
            return;
        }
        this.detectorCandidateRealtimeError = '';
        this.detectorCandidateRealtimeOn = true;
        this.detectorCandidateRealtimeFrame = null;
        this.detectorCandidateRealtimeFramesProcessed = 0;
        this.detectorCandidateTestGtMode = false;
        this.resetDetectorCandidateRealtimeTracking();
        const generation = ++this.detectorCandidateRealtimeGeneration;
        await this.service.render();
        const video = document.getElementById(
            'detector-candidate-test-video'
        ) as HTMLVideoElement;
        if (!video) {
            this.detectorCandidateRealtimeError = '선택한 동영상 플레이어를 열 수 없습니다.';
            this.stopDetectorCandidateRealtime();
            return;
        }
        try {
            if (video.ended) video.currentTime = 0;
            await video.play();
        } catch (_error) {
            this.detectorCandidateRealtimeError = '동영상을 재생할 수 없습니다. 파일 형식을 확인해 주세요.';
            this.stopDetectorCandidateRealtime();
            return;
        }
        this.scheduleDetectorCandidateRealtimeFrame(generation, 0);
    }

    public stopDetectorCandidateRealtime(render = true, pauseVideo = true) {
        this.detectorCandidateRealtimeGeneration += 1;
        if (this.detectorCandidateRealtimeTimer) {
            clearTimeout(this.detectorCandidateRealtimeTimer);
            this.detectorCandidateRealtimeTimer = null;
        }
        if (pauseVideo) {
            const video = document.getElementById(
                'detector-candidate-test-video'
            ) as HTMLVideoElement;
            if (video && !video.paused) video.pause();
        }
        this.detectorCandidateRealtimeOn = false;
        this.detectorCandidateRealtimeBusy = false;
        if (render) void this.service.render();
    }

    private resetDetectorCandidateRealtimeTracking() {
        this.detectorCandidateRealtimeTrackingId = (
            (window.crypto as any)?.randomUUID?.()
            || `candidate-${Date.now()}-${Math.random().toString(16).slice(2)}`
        );
    }

    public onDetectorCandidateRealtimeSeeked() {
        if (!this.detectorCandidateRealtimeOn) return;
        this.detectorCandidateRealtimeFrame = null;
        this.resetDetectorCandidateRealtimeTracking();
        const generation = ++this.detectorCandidateRealtimeGeneration;
        this.scheduleDetectorCandidateRealtimeFrame(generation, 0);
    }

    public onDetectorCandidateRealtimeEnded() {
        if (this.detectorCandidateRealtimeOn) {
            this.stopDetectorCandidateRealtime(true, false);
        }
    }

    private scheduleDetectorCandidateRealtimeFrame(
        generation: number, delay = 150
    ) {
        if (
            generation !== this.detectorCandidateRealtimeGeneration
            || !this.detectorCandidateRealtimeOn
        ) return;
        this.detectorCandidateRealtimeTimer = setTimeout(
            () => void this.captureDetectorCandidateRealtimeFrame(generation),
            delay,
        );
    }

    private async captureDetectorCandidateRealtimeFrame(generation: number) {
        if (
            generation !== this.detectorCandidateRealtimeGeneration
            || !this.detectorCandidateRealtimeOn
        ) return;
        if (this.detectorCandidateRealtimeBusy) {
            this.scheduleDetectorCandidateRealtimeFrame(generation, 100);
            return;
        }
        const video = document.getElementById(
            'detector-candidate-test-video'
        ) as HTMLVideoElement;
        if (!video?.videoWidth || video.readyState < 2) {
            this.scheduleDetectorCandidateRealtimeFrame(generation, 250);
            return;
        }
        if (video.ended) {
            this.stopDetectorCandidateRealtime(true, false);
            return;
        }
        if (video.paused || video.seeking) {
            this.scheduleDetectorCandidateRealtimeFrame(generation, 200);
            return;
        }
        this.detectorCandidateRealtimeBusy = true;
        try {
            const sourceTime = Number(video.currentTime || 0);
            const canvas = document.createElement('canvas');
            const scale = Math.min(1, 640 / video.videoWidth);
            canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
            canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
            const context = canvas.getContext('2d');
            if (!context) throw new Error('동영상 프레임을 읽을 수 없습니다.');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(
                resolve, 'image/jpeg', 0.78,
            ));
            if (!blob) throw new Error('동영상 프레임을 만들 수 없습니다.');
            const form = new FormData();
            form.append('image', blob, 'candidate-live.jpg');
            form.append('candidate_sha256', this.detectorCandidateTestModelSha);
            form.append('tracking_id', this.detectorCandidateRealtimeTrackingId);
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 90000);
            let response: Response | null = null;
            let payload: any = null;
            try {
                response = await fetch(
                    '/wiz/api/page.xray.experiments/test_detector_candidate_realtime_frame_v1',
                    {
                        method: 'POST', body: form, credentials: 'same-origin',
                        signal: controller.signal,
                    },
                );
                payload = await response.json();
            } finally {
                clearTimeout(timeout);
            }
            const code = Number(payload?.code || response?.status || 500);
            const data = payload?.data || payload || {};
            if (code !== 200) throw new Error(
                data?.message || `Candidate 실시간 테스트에 실패했습니다. (${code})`
            );
            if (generation !== this.detectorCandidateRealtimeGeneration) return;
            const currentTime = Number(video.currentTime || 0);
            const stale = !video.paused && Math.abs(currentTime - sourceTime) > .35;
            if (stale) {
                this.detectorCandidateRealtimeFrame = null;
                return;
            }
            this.detectorCandidateRealtimeFrame = data?.result
                ? { ...data.result, source_time_seconds: sourceTime }
                : null;
            this.detectorCandidateRealtimeFramesProcessed += 1;
            this.detectorCandidateRealtimeError = '';
        } catch (error: any) {
            if (generation === this.detectorCandidateRealtimeGeneration) {
                this.detectorCandidateRealtimeError = error?.name === 'AbortError'
                    ? 'Candidate 실시간 테스트 응답이 90초를 초과했습니다.'
                    : this.callError(error, 'Candidate 실시간 테스트에 실패했습니다.');
            }
        } finally {
            this.detectorCandidateRealtimeBusy = false;
            if (generation === this.detectorCandidateRealtimeGeneration) {
                await this.service.render();
                this.scheduleDetectorCandidateRealtimeFrame(
                    generation,
                    this.detectorCandidateRealtimeError ? 1200 : 0,
                );
            }
        }
    }

    public detectorCandidateRealtimePolygonPoints() {
        return (this.detectorCandidateRealtimeFrame?.polygon || [])
            .map((point: number[]) => `${point[0] * 1000},${point[1] * 1000}`)
            .join(' ');
    }

    public detectorCandidateRealtimeStatusLabel() {
        if (!this.detectorCandidateRealtimeFrame) return '첫 검출을 준비하고 있습니다.';
        if (this.detectorCandidateRealtimeFrame.detected) {
            return '현재 Bucky 위치 · Candidate 원본 검출';
        }
        return '현재 프레임 Bucky 미검출';
    }

    public async runDetectorCandidateVideoTest() {
        if (!this.detectorCandidateTestFile || !this.detectorCandidateTestModelSha || this.detectorCandidateTestBusy) return;
        this.stopDetectorCandidateRealtime(false);
        this.detectorCandidateTestBusy = true; this.errorMessage = ''; this.notice = '';
        await this.service.render();
        try {
            const form = new FormData();
            form.append('file', this.detectorCandidateTestFile, this.detectorCandidateTestFile.name);
            form.append('candidate_sha256', this.detectorCandidateTestModelSha);
            const { code, data } = await wiz.call('test_detector_candidate_video_v12', form, {
                processData: false, contentType: false,
            });
            if (code !== 200) throw new Error(data?.message || 'Candidate 동영상 테스트가 실패했습니다.');
            this.detectorCandidateTestResult = data?.result || null;
            this.detectorCandidateTestPassed = false;
            const representativeFrames = this.detectorCandidateTestResult?.frames || [];
            this.detectorCandidateTestFrame = representativeFrames.find(
                (frame: any) => frame?.detected
            ) || representativeFrames[0] || null;
            this.detectorCandidateTestGtMode = false;
            this.resetDetectorCandidateGt();
            this.detectorCandidateTestFailureSaved = null;
            this.notice = '업그레이드 Candidate로 대표 프레임 동영상 테스트를 완료했습니다. 운영 모델은 변경하지 않았습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Candidate 동영상 테스트가 실패했습니다.');
        }
        this.detectorCandidateTestBusy = false;
        await this.service.render();
        const selectedVideo = document.getElementById(
            'detector-candidate-test-video'
        ) as HTMLVideoElement;
        if (selectedVideo && this.detectorCandidateTestFrame) {
            selectedVideo.currentTime = Number(
                this.detectorCandidateTestFrame.timestamp_seconds || 0
            );
        }
    }

    public async markDetectorCandidateTestPassed() {
        const result = this.detectorCandidateTestResult;
        if (
            !result?.test_pass_eligible
            || !result?.test_id
            || this.detectorCandidateTestPassBusy
            || this.detectorCandidateTestFailureSaved
        ) return;
        if (!window.confirm(
            '이 동영상 결과를 사람이 확인한 테스트 통과 모델로 등록할까요?\n\n운영 모델은 아직 변경되지 않습니다.'
        )) return;
        this.detectorCandidateTestPassBusy = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('mark_detector_candidate_test_pass_v14', {
                test_id: result.test_id,
                candidate_sha256: this.detectorCandidateTestModelSha,
            });
            if (code !== 200) throw new Error(data?.message || '테스트 통과 모델을 저장하지 못했습니다.');
            this.detectorCandidateTestPassed = true;
            this.detectorCandidateTestResult.test_pass_status = 'PASSED';
            this.notice = 'Bucky Candidate를 테스트 통과 모델로 등록했습니다. 모델 관리에서 운영 변경할 수 있습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '테스트 통과 모델을 저장하지 못했습니다.');
        } finally {
            this.detectorCandidateTestPassBusy = false;
            await this.service.render();
        }
    }

    public onDetectorCandidateTestTimeUpdate(event: Event) {
        if (this.detectorCandidateRealtimeOn) return;
        const video = event.target as HTMLVideoElement;
        const frames = this.detectorCandidateTestResult?.tracking_frames
            || this.detectorCandidateTestResult?.frames || [];
        if (!frames.length) return;
        const nearest = frames.reduce((best: any, frame: any) => (
            Math.abs(Number(frame?.timestamp_seconds || 0) - video.currentTime)
                < Math.abs(Number(best?.timestamp_seconds || 0) - video.currentTime)
                ? frame : best
        ), frames[0]);
        if (nearest?.frame_index !== this.detectorCandidateTestFrame?.frame_index) {
            this.detectorCandidateTestFrame = nearest;
            this.service.render();
        }
    }

    public selectDetectorCandidateTestFrame(frame: any) {
        this.stopDetectorCandidateRealtime(false);
        this.detectorCandidateTestFrame = frame;
        const video = document.getElementById('detector-candidate-test-video') as HTMLVideoElement;
        if (video) video.currentTime = Number(frame?.timestamp_seconds || 0);
    }

    public selectDetectorMovementReviewTarget(frame: any) {
        this.stopDetectorCandidateRealtime(false);
        this.detectorCandidateMovementPhase = frame?.movement_phase || 'moving';
        this.detectorCandidateTestFrame = frame;
        this.detectorCandidateTestGtMode = false;
        this.resetDetectorCandidateGt();
        this.detectorCandidateTestFailureSaved = null;
        const video = document.getElementById('detector-candidate-test-video') as HTMLVideoElement;
        if (video) {
            video.pause();
            video.currentTime = Number(frame?.timestamp_seconds || 0);
        }
        this.service.render();
    }

    public detectorCandidateRejectionSummary() {
        const reasons = this.detectorCandidateTestResult?.tracking_rejection_reasons || {};
        return Object.entries(reasons)
            .map(([reason, count]) => `${reason} ${count}`)
            .join(' · ');
    }

    public detectorCandidateTestPolygonPoints() {
        return (this.detectorCandidateTestFrame?.display_polygon || this.detectorCandidateTestFrame?.polygon || [])
            .map((point: any) => `${Number(point?.[0] || 0) * 1000},${Number(point?.[1] || 0) * 1000}`)
            .join(' ');
    }

    public detectorCandidateTestRawPolygonPoints() {
        return (this.detectorCandidateTestFrame?.raw_display_polygon || this.detectorCandidateTestFrame?.raw_polygon || this.detectorCandidateTestFrame?.polygon || [])
            .map((point: any) => `${Number(point?.[0] || 0) * 1000},${Number(point?.[1] || 0) * 1000}`)
            .join(' ');
    }

    public detectorCandidateTestDisplayPolygon() {
        return this.detectorCandidateTestFrame?.display_polygon
            || this.detectorCandidateTestFrame?.polygon
            || [];
    }

    public startDetectorCandidateFailureGt() {
        this.stopDetectorCandidateRealtime(false);
        const video = document.getElementById('detector-candidate-test-video') as HTMLVideoElement;
        if (video) video.pause();
        this.resetDetectorCandidateGt();
        this.detectorCandidateTestGtMode = true;
        this.detectorCandidateTestFailureSaved = null;
        this.service.render();
    }

    public selectDetectorCandidateMovementPhase(phase: 'before' | 'moving' | 'after') {
        this.detectorCandidateMovementPhase = phase;
        this.service.render();
    }

    public addDetectorCandidateGtPoint(event: MouseEvent) {
        if (!this.detectorCandidateTestGtMode) return;
        const target = event.currentTarget as SVGElement;
        const bounds = target.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const point = [
            Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width)),
            Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height)),
        ];
        const points = [...this.detectorCandidateTestGtPoints];
        const sources = [...this.detectorCandidateTestGtCornerSources];
        points[this.detectorCandidateTestGtSelectedCorner] = point;
        sources[this.detectorCandidateTestGtSelectedCorner] = 'OBSERVED';
        this.detectorCandidateTestGtPoints = points;
        this.detectorCandidateTestGtCornerSources = sources;
        const next = points.findIndex((value: any) => !value);
        if (next >= 0) this.detectorCandidateTestGtSelectedCorner = next;
        else this.detectorCandidateTestGtMode = false;
        this.service.render();
    }

    public detectorCandidateTestGtPolygonPoints(close = false) {
        const points = this.detectorCandidateTestGtPoints.filter((point: any) => !!point);
        if (close && this.detectorCandidateGtComplete()) points.push(points[0]);
        return points.map((point: any) => `${point[0] * 1000},${point[1] * 1000}`).join(' ');
    }

    public detectorCandidateGtNextLabel() {
        return ['좌상', '우상', '우하', '좌하'][this.detectorCandidateTestGtSelectedCorner] || '완료';
    }

    public selectDetectorCandidateGtCorner(index: number) {
        this.detectorCandidateTestGtSelectedCorner = index;
        this.detectorCandidateTestGtMode = true;
        this.service.render();
    }

    public detectorCandidateGtMarkers() {
        return this.detectorCandidateTestGtPoints
            .map((point: any, index: number) => ({
                point, index, source: this.detectorCandidateTestGtCornerSources[index],
            }))
            .filter((marker: any) => !!marker.point);
    }

    public detectorCandidateGtFilledCount() {
        return this.detectorCandidateTestGtPoints.filter((point: any) => !!point).length;
    }

    public detectorCandidateGtComplete() {
        return this.detectorCandidateGtFilledCount() === 4;
    }

    public canInferDetectorCandidateGt() {
        const known = this.detectorCandidateTestGtPoints
            .map((point: any, index: number) => point ? index : -1)
            .filter((index: number) => index >= 0);
        if (known.length === 3) return true;
        if (known.length !== 2) return false;
        const key = [...known].sort().join('-');
        return ['0-1', '1-2', '2-3', '0-3'].includes(key);
    }

    public inferDetectorCandidateGtCorners() {
        if (!this.canInferDetectorCandidateGt()) {
            this.errorMessage = '가린 점 유추에는 보이는 모서리 3개 또는 서로 붙어 있는 모서리 2개가 필요합니다.';
            return;
        }
        const points = this.detectorCandidateTestGtPoints.map((point: any) => point ? [...point] : null);
        const sources = [...this.detectorCandidateTestGtCornerSources];
        const known = points.map((point: any, index: number) => point ? index : -1).filter((index: number) => index >= 0);
        const setInferred = (index: number, point: number[]) => {
            points[index] = [
                Math.max(0, Math.min(1, point[0])),
                Math.max(0, Math.min(1, point[1])),
            ];
            sources[index] = 'INFERRED';
        };
        if (known.length === 3) {
            const missing = [0, 1, 2, 3].find((index: number) => !points[index]) as number;
            if (missing === 0) setInferred(0, [points[1][0] + points[3][0] - points[2][0], points[1][1] + points[3][1] - points[2][1]]);
            if (missing === 1) setInferred(1, [points[0][0] + points[2][0] - points[3][0], points[0][1] + points[2][1] - points[3][1]]);
            if (missing === 2) setInferred(2, [points[1][0] + points[3][0] - points[0][0], points[1][1] + points[3][1] - points[0][1]]);
            if (missing === 3) setInferred(3, [points[0][0] + points[2][0] - points[1][0], points[0][1] + points[2][1] - points[1][1]]);
        } else {
            const ratio = this.detectorCandidateGtHeightWidthRatio();
            const key = [...known].sort().join('-');
            const scaledNormal = (from: number[], to: number[], scale: number, direction: number) => {
                const dx = to[0] - from[0]; const dy = to[1] - from[1];
                return [-dy * scale * direction, dx * scale * direction];
            };
            if (key === '0-1') {
                const vector = scaledNormal(points[0], points[1], ratio, 1);
                setInferred(3, [points[0][0] + vector[0], points[0][1] + vector[1]]);
                setInferred(2, [points[1][0] + vector[0], points[1][1] + vector[1]]);
            } else if (key === '2-3') {
                const vector = scaledNormal(points[3], points[2], ratio, 1);
                setInferred(0, [points[3][0] - vector[0], points[3][1] - vector[1]]);
                setInferred(1, [points[2][0] - vector[0], points[2][1] - vector[1]]);
            } else if (key === '0-3') {
                const vector = scaledNormal(points[0], points[3], 1 / ratio, -1);
                setInferred(1, [points[0][0] + vector[0], points[0][1] + vector[1]]);
                setInferred(2, [points[3][0] + vector[0], points[3][1] + vector[1]]);
            } else if (key === '1-2') {
                const vector = scaledNormal(points[1], points[2], 1 / ratio, -1);
                setInferred(0, [points[1][0] - vector[0], points[1][1] - vector[1]]);
                setInferred(3, [points[2][0] - vector[0], points[2][1] - vector[1]]);
            }
        }
        this.detectorCandidateTestGtPoints = points;
        this.detectorCandidateTestGtCornerSources = sources;
        this.detectorCandidateTestGtMode = false;
        this.errorMessage = '';
        this.service.render();
    }

    private detectorCandidateGtHeightWidthRatio() {
        const learned = Number(this.detectorCandidateTestResult?.calibration?.gt_height_width_ratio || 0);
        if (learned > 0.5 && learned < 3) return learned;
        const polygon = this.detectorCandidateTestFrame?.polygon || [];
        if (polygon.length === 4) {
            const distance = (first: any, second: any) => Math.hypot(second[0] - first[0], second[1] - first[1]);
            const width = (distance(polygon[0], polygon[1]) + distance(polygon[3], polygon[2])) / 2;
            const height = (distance(polygon[0], polygon[3]) + distance(polygon[1], polygon[2])) / 2;
            if (width > 0) return height / width;
        }
        return 1.6;
    }

    private resetDetectorCandidateGt() {
        this.detectorCandidateTestGtPoints = [null, null, null, null];
        this.detectorCandidateTestGtCornerSources = ['MISSING', 'MISSING', 'MISSING', 'MISSING'];
        this.detectorCandidateTestGtSelectedCorner = 0;
    }

    public async saveDetectorCandidateFailureGt() {
        if (!this.detectorCandidateGtComplete() || this.detectorCandidateTestGtSaving) return;
        const video = document.getElementById('detector-candidate-test-video') as HTMLVideoElement;
        if (!video?.videoWidth || !video?.videoHeight) {
            this.errorMessage = '동영상 대표 프레임을 읽을 수 없습니다.';
            return;
        }
        this.detectorCandidateTestGtSaving = true; this.errorMessage = '';
        await this.service.render();
        try {
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth; canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) throw new Error('대표 프레임 캔버스를 만들 수 없습니다.');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.95));
            if (!blob) throw new Error('대표 프레임을 저장할 수 없습니다.');
            const form = new FormData();
            form.append('file', blob, 'candidate-video-failure.jpg');
            form.append('metadata', JSON.stringify({
                candidate_weight_sha256: this.detectorCandidateTestModelSha,
                source_filename: this.detectorCandidateTestFile?.name || '',
                video_sha256: this.detectorCandidateTestResult?.video_sha256 || '',
                timestamp_seconds: Number(video.currentTime || this.detectorCandidateTestFrame?.timestamp_seconds || 0),
                candidate_polygon: this.detectorCandidateTestFrame?.raw_polygon || this.detectorCandidateTestFrame?.polygon || null,
                refined_polygon: this.detectorCandidateTestFrame?.polygon || null,
                calibration: this.detectorCandidateTestResult?.calibration || null,
                gt_polygon: this.detectorCandidateTestGtPoints,
                gt_corner_sources: this.detectorCandidateTestGtCornerSources,
                movement_phase: this.detectorCandidateMovementPhase,
            }));
            const { code, data } = await wiz.call('save_detector_candidate_failure_gt_v13', form, {
                processData: false, contentType: false,
            });
            if (code !== 201) throw new Error(data?.message || '실패 GT를 저장하지 못했습니다.');
            this.detectorCandidateTestFailureSaved = data?.record || null;
            this.notice = '오검출 대표 프레임과 실제 패널 GT를 저장했습니다. 다음 Candidate 준비에 자동 포함되며 현재 모델의 운영 승인은 차단됩니다.';
            await this.loadPilotSummary(true);
        } catch (error: any) {
            this.errorMessage = this.callError(error, '실패 GT를 저장하지 못했습니다.');
        }
        this.detectorCandidateTestGtSaving = false;
        await this.service.render();
    }

    public detectorCandidateTestModelLabel() {
        return this.detectorCandidateModels.find(
            (model: any) => model?.weight_sha256 === this.detectorCandidateTestModelSha
        )?.label || '업그레이드 Candidate';
    }

    private clearDetectorCandidateTestVideo() {
        this.stopDetectorCandidateRealtime(false);
        if (this.detectorCandidateTestVideoUrl) URL.revokeObjectURL(this.detectorCandidateTestVideoUrl);
        this.detectorCandidateTestVideoUrl = '';
        this.detectorCandidateTestFile = null;
    }

    public pilotQueueGroupCount(group: string) {
        return Number(this.pilotSummary?.queue_counts?.[group] || 0);
    }

    public async preparePilotFineTuning() {
        if (!this.pilotSummary?.training_ready || this.actionBusy) return;
        this.actionBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('prepare_pilot_finetuning_v7', {});
            if (code === 200) {
                this.notice = '공용파일 포함 candidate 보정 학습 데이터와 실행 명령을 준비했습니다. 실제 학습은 아직 시작하지 않았습니다.';
            } else this.errorMessage = data?.message || '보정 학습 데이터를 준비하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '보정 학습 데이터를 준비하지 못했습니다.');
        }
        this.actionBusy = false;
        await this.loadPilotSummary(true);
    }

    public async refreshPublicInventory() {
        if (this.actionBusy) return;
        this.actionBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('refresh_public_inventory_v8', {});
            if (code === 200) {
                this.pilotSummary = data?.summary || this.pilotSummary;
                this.notice = `공용파일을 다시 읽었습니다. 고유 ${this.pilotSummary?.public_file_count || 0}장 중 ${this.publicPredictionPending()}장은 자동 예측과 검수 큐 등록이 필요합니다.`;
            } else this.errorMessage = data?.message || '공용파일을 다시 읽지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '공용파일을 다시 읽지 못했습니다.');
        }
        this.actionBusy = false;
        await this.service.render();
    }

    public publicQueueJobRunning() {
        return ['queued', 'running'].includes(this.publicQueueJob?.status);
    }

    public publicQueueProgress() {
        const total = Math.max(0, Number(this.publicQueueJob?.total || 0));
        const processed = Math.max(0, Number(this.publicQueueJob?.processed || 0));
        return total ? Math.min(100, Math.round(processed / total * 100)) : 0;
    }

    public async startPublicQueueRegistration() {
        if (this.publicQueueBusy || this.publicQueueJobRunning() || !this.publicPredictionPending()) return;
        this.publicQueueBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('start_public_queue_registration_v9', {});
            if (![200, 202].includes(code)) throw new Error(data?.message || '공용파일 자동 예측을 시작하지 못했습니다.');
            this.publicQueueJob = data?.job || this.publicQueueJob;
            this.notice = `공용파일 ${this.publicQueueJob?.total || this.publicPredictionPending()}장의 운영 모델 자동 예측과 검수 큐 등록을 시작했습니다.`;
            if (this.publicQueueJobRunning()) this.startPublicQueuePolling();
        } catch (error: any) {
            this.errorMessage = this.callError(error, '공용파일 자동 예측을 시작하지 못했습니다.');
        }
        this.publicQueueBusy = false;
        await this.service.render();
    }

    public async loadPublicQueueJob(quiet = false) {
        try {
            const { code, data } = await wiz.call('public_queue_registration_status_v9', {});
            if (code !== 200) throw new Error(data?.message || '자동 예측 현황을 불러오지 못했습니다.');
            this.publicQueueJob = data?.job || null;
            if (data?.summary) this.pilotSummary = data.summary;
            if (this.publicQueueJobRunning()) this.startPublicQueuePolling();
        } catch (error: any) {
            if (!quiet) this.errorMessage = this.callError(error, '자동 예측 현황을 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public async pollPublicQueueJob() {
        const previous = this.publicQueueJob?.status;
        await this.loadPublicQueueJob(true);
        if (!this.publicQueueJobRunning()) {
            this.stopPublicQueuePolling();
            await this.loadPilotSummary(true);
            if (this.publicQueueJob?.status === 'completed' && previous !== 'completed') {
                this.notice = `자동 예측 ${this.publicQueueJob?.processed || 0}장 처리, ${this.publicQueueJob?.registered || 0}장 큐 등록을 완료했습니다. 이제 공용파일 좌표를 검수하세요.`;
            } else if (this.publicQueueJob?.status === 'failed') {
                this.errorMessage = this.publicQueueJob?.error || '공용파일 자동 예측 작업이 실패했습니다.';
            }
            await this.service.render();
        }
    }

    private startPublicQueuePolling() {
        if (this.publicQueuePollTimer) return;
        this.publicQueuePollTimer = setInterval(() => this.pollPublicQueueJob(), 2000);
    }

    private stopPublicQueuePolling() {
        if (this.publicQueuePollTimer) clearInterval(this.publicQueuePollTimer);
        this.publicQueuePollTimer = null;
    }

    public async startBatchAnalysis() {
        if (this.batchBusy || ['queued', 'running'].includes(this.batchJob?.status)) return;
        this.batchBusy = true; this.errorMessage = ''; this.notice = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('batch_start', { resume: true });
            if (code === 202) {
                this.batchJob = data?.job; this.notice = '운영 pose+Bucky+관계 특징 일괄 분석을 queue에 등록했습니다.';
                this.startBatchPolling();
            } else this.errorMessage = data?.message || '일괄 분석을 시작하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '일괄 분석을 시작하지 못했습니다.'); }
        this.batchBusy = false; await this.service.render();
    }

    public async cancelBatchAnalysis() {
        if (!this.batchJob?.job_id || this.batchBusy) return;
        this.batchBusy = true;
        const { code, data } = await this.trainingCall('batch_cancel', { job_id: this.batchJob.job_id });
        if (code === 200) { this.batchJob = data?.job; this.notice = '현재 이미지 저장 후 중단하도록 요청했습니다.'; }
        else this.errorMessage = data?.message || '중단 요청을 저장하지 못했습니다.';
        this.batchBusy = false; await this.service.render();
    }

    private startBatchPolling() {
        this.stopBatchPolling();
        this.batchPollTimer = setInterval(() => this.pollBatch(), 2000);
        this.pollBatch();
    }

    private stopBatchPolling() {
        if (this.batchPollTimer) clearInterval(this.batchPollTimer);
        this.batchPollTimer = null;
    }

    public async pollBatch() {
        if (!this.batchJob?.job_id) return;
        try {
            const { code, data } = await wiz.call('batch_analysis_status_v6', { job_id: this.batchJob.job_id });
            if (code === 200) {
                this.batchJob = data?.job; this.batchSummary = data?.summary || this.batchSummary;
                if (['completed', 'failed', 'cancelled'].includes(this.batchJob?.status)) this.stopBatchPolling();
            }
        } catch (_) { }
        await this.service.render();
    }

    public exportBatchManifest() {
        window.location.href = '/wiz/api/page.xray.experiments/load_paper_state_v2?training_action=batch_manifest';
    }

    public async startMultitaskTraining() {
        if (this.batchBusy) return;
        this.batchBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('multitask_start');
            if (code === 202) this.notice = '검수 manifest가 준비되었습니다. 새 모델은 shadow 후보로만 생성됩니다.';
            else this.errorMessage = data?.message || '4항목 학습을 시작할 수 없습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '4항목 학습을 시작할 수 없습니다.'); }
        this.batchBusy = false; await this.service.render();
    }

    public postureCount(code: string, status: string) { return Number(this.batchSummary?.posture_distributions?.[code]?.[status] || 0); }
    public itemEligibility(code: string) { return this.batchSummary?.training_eligibility?.heads?.[code] || { trainable: false, status: 'INSUFFICIENT_LABELS' }; }

    public profile(key: string) {
        return (this.capabilities?.profiles || []).find((item: any) => item?.key === key);
    }

    public normalityReview() {
        return this.capabilities?.normality_review || {
            total: 0, reviewed: 0, unreviewed: 0, normal: 0,
            abnormal: 0, hold: 0, trainable: false,
            fresh_video_count: 0, fresh_video_frame_count: 0,
            pose_review_total_count: 0, pose_reviewed_unique_count: 0,
            pose_unreviewed_unique_count: 0, pose_unique_progress_percent: 0,
            pose_reviewed_image_count: 0, pose_unreviewed_image_count: 0,
            pose_reviewed_video_count: 0, pose_unreviewed_video_count: 0,
            reviewed_video_count: 0, unreviewed_video_count: 0,
            reviewed_video_frame_count: 0, unreviewed_video_frame_count: 0,
            reason_counts: {},
            missing: { normal: 30, abnormal: 60, reasons: {} },
            minimum: { normal: 30, abnormal: 60, per_reason: 10 },
        };
    }

    public judgementProfiles() {
        return (this.capabilities?.profiles || []).filter((item: any) => item?.key === 'operating_posture_classifier');
    }

    public coordinateModelProfiles() {
        return (this.capabilities?.profiles || []).filter((item: any) => ['yolo_camera_dual', 'yolo_pose_retry'].includes(item?.key));
    }

    public poseModelOptions() { return this.poseModels?.models || []; }

    public selectedPoseModel() {
        return this.poseModelOptions().find((item: any) => item?.key === this.configuration.pose_model) || null;
    }

    public selectPoseModel(key: string) {
        if (!this.poseModelOptions().some((item: any) => item?.key === key)) return;
        this.configuration.pose_model = key;
        this.service.render();
    }

    public isYoloProfileSelected() {
        return ['yolo_camera_dual', 'yolo_pose_retry'].includes(this.configuration.profile);
    }

    public poseWeightImporting() {
        return ['queued', 'running'].includes(String(this.poseModels?.import_job?.status || ''));
    }

    public poseWeightStatusLabel(item: any) {
        if (item?.ready) return '준비됨';
        if (this.poseWeightImporting() && (this.poseModels?.import_job?.requested_models || []).includes(item?.key)) return '가져오는 중';
        return '미준비';
    }

    public async importPoseWeights(modelKey = '') {
        if (this.poseWeightBusy || this.poseWeightImporting()) return;
        const models = modelKey ? [modelKey] : this.poseModelOptions().map((item: any) => item.key);
        if (!models.length) return;
        this.poseWeightBusy = true; this.notice = ''; this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await this.trainingCall('pose_weights_import', { models: JSON.stringify(models) });
            if (code === 202) {
                this.poseModels = data?.pose_models || this.poseModels;
                this.notice = modelKey ? '선택한 공식 Pose 가중치를 가져오고 있습니다.' : '공식 Pose 가중치 4개를 가져오고 있습니다.';
                this.startPoseWeightPolling();
            } else this.errorMessage = data?.message || '공식 Pose 가중치 가져오기를 시작하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '공식 Pose 가중치 가져오기를 시작하지 못했습니다.');
        }
        this.poseWeightBusy = false;
        await this.service.render();
    }

    public async refreshPoseWeightStatus(quiet = false) {
        const previousStatus = String(this.poseModels?.import_job?.status || '');
        try {
            const { code, data } = await this.trainingCall('pose_weights_status');
            if (code === 200) {
                this.poseModels = data?.pose_models || this.poseModels;
                const currentStatus = String(this.poseModels?.import_job?.status || '');
                if (currentStatus === 'completed' && previousStatus !== 'completed') {
                    this.notice = `공식 Pose 가중치 ${this.poseModels?.ready_count || 0}개 준비를 완료했습니다.`;
                }
                if (!this.poseWeightImporting()) this.stopPoseWeightPolling();
            } else if (!quiet) this.errorMessage = data?.message || '공식 Pose 가중치 상태를 확인하지 못했습니다.';
        } catch (error: any) {
            if (!quiet) this.errorMessage = this.callError(error, '공식 Pose 가중치 상태를 확인하지 못했습니다.');
        }
        await this.service.render();
    }

    private startPoseWeightPolling() {
        this.stopPoseWeightPolling();
        this.poseWeightPollTimer = setInterval(() => this.refreshPoseWeightStatus(true), 1500);
    }

    private stopPoseWeightPolling() {
        if (this.poseWeightPollTimer) clearInterval(this.poseWeightPollTimer);
        this.poseWeightPollTimer = null;
    }

    public researchProfiles() {
        return (this.capabilities?.profiles || []).filter((item: any) => !['operating_posture_classifier', 'yolo_camera_dual', 'yolo_pose_retry'].includes(item?.key));
    }

    public normalityReasonCount(code: string) { return Number(this.normalityReview()?.reason_counts?.[code] || 0); }

    public judgementExperiments() {
        return this.experiments.filter(
            (item: any) => item?.configuration?.profile === 'operating_posture_classifier'
        );
    }

    public judgementImageReviewRemainingCount() {
        const explicit = this.normalityReview()?.judgement_ready_image_count;
        if (explicit !== undefined && explicit !== null) {
            return Math.max(0, Number(explicit));
        }
        return Math.max(0, Number(this.normalityReview()?.unreviewed || 0)
            - Number(this.normalityReview()?.unreviewed_video_frame_count || 0));
    }

    public judgementVideoReviewRemainingCount() {
        const explicit = this.normalityReview()?.judgement_ready_video_count;
        if (explicit !== undefined && explicit !== null) {
            return Math.max(0, Number(explicit));
        }
        return Math.max(0, Number(
            this.normalityReview()?.unreviewed_video_count
            ?? this.normalityReview()?.fresh_video_count
            ?? 0
        ));
    }

    public judgementReviewPrerequisites(media: 'image' | 'video') {
        const inventory = this.reviewedDataset?.inventory_counts || {};
        const total = Number(inventory?.[`${media}_source`] || 0);
        const poseReviewed = Number(inventory?.[`${media}_pose_reviewed`] || 0);
        const detectorReviewed = Number(inventory?.[`${media}_detector_reviewed`] || 0);
        const readyCount = media === 'video'
            ? this.judgementVideoReviewRemainingCount()
            : this.judgementImageReviewRemainingCount();
        return {
            total,
            poseReviewed,
            detectorReviewed,
            readyCount,
            ready: readyCount > 0,
        };
    }

    public judgementPrerequisiteLabel(media: 'image' | 'video') {
        const state = this.judgementReviewPrerequisites(media);
        const unit = media === 'video' ? '개' : '장';
        return `검수 가능 ${state.readyCount}${unit} · 자세 ${state.poseReviewed}/${state.total} · 디텍터 ${state.detectorReviewed}/${state.total}`;
    }

    public scrollToJudgementResults() {
        document.getElementById('judgement-training-results')?.scrollIntoView({
            behavior: 'smooth', block: 'start',
        });
    }

    public judgementTestableExperiments() {
        return this.judgementExperiments().filter((item: any) => item?.status === 'completed');
    }

    public onJudgementCandidateTestExperimentChange() {
        this.stopJudgementCandidateTest(false);
        this.judgementCandidateTestFrame = null;
        this.judgementCandidateEvaluatedFrameCount = 0;
        this.judgementCandidateTestPassed = false;
        this.judgementCandidateTestError = '';
        void this.service.render();
    }

    public onJudgementCandidateTestVideo(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0] || null;
        this.clearJudgementCandidateTestVideo();
        this.judgementCandidateTestFile = file;
        if (file) this.judgementCandidateTestVideoUrl = URL.createObjectURL(file);
        input.value = '';
        void this.service.render();
    }

    public clearJudgementCandidateTestVideo() {
        this.stopJudgementCandidateTest(false);
        if (this.judgementCandidateTestVideoUrl) URL.revokeObjectURL(this.judgementCandidateTestVideoUrl);
        this.judgementCandidateTestFile = null;
        this.judgementCandidateTestVideoUrl = '';
        this.judgementCandidateTestFrame = null;
        this.judgementCandidateEvaluatedFrameCount = 0;
        this.judgementCandidateTestPassed = false;
        this.judgementCandidateTestError = '';
    }

    public async startJudgementCandidateTest() {
        if (this.judgementCandidateTestRunning || this.judgementCandidateTestBusy) return;
        if (!this.judgementCandidateTestExperimentId) {
            this.judgementCandidateTestError = '학습 완료된 자세 판정 후보를 선택해 주세요.';
            await this.service.render(); return;
        }
        if (!this.judgementCandidateTestVideoUrl) {
            this.judgementCandidateTestError = '테스트할 동영상을 선택해 주세요.';
            await this.service.render(); return;
        }
        const video = document.getElementById('judgement-candidate-test-video') as HTMLVideoElement;
        if (!video) return;
        this.judgementCandidateTestRunning = true;
        this.judgementCandidateTestError = '';
        this.judgementCandidateTestFrame = null;
        this.judgementCandidateEvaluatedFrameCount = 0;
        this.judgementCandidateTestPassed = false;
        const generation = ++this.judgementCandidateTestGeneration;
        await this.service.render();
        try {
            if (video.ended) video.currentTime = 0;
            await video.play();
            this.scheduleJudgementCandidateTestFrame(generation, 0);
        } catch (_) {
            this.judgementCandidateTestError = '동영상을 재생할 수 없습니다.';
            this.stopJudgementCandidateTest();
        }
    }

    public stopJudgementCandidateTest(render = true, pauseVideo = true) {
        this.judgementCandidateTestGeneration += 1;
        if (this.judgementCandidateTestTimer) clearTimeout(this.judgementCandidateTestTimer);
        this.judgementCandidateTestTimer = null;
        if (pauseVideo) {
            const video = document.getElementById('judgement-candidate-test-video') as HTMLVideoElement;
            if (video && !video.paused) video.pause();
        }
        this.judgementCandidateTestRunning = false;
        this.judgementCandidateTestBusy = false;
        if (render) void this.service.render();
    }

    public onJudgementCandidateTestEnded() {
        this.stopJudgementCandidateTest(true, false);
    }

    private scheduleJudgementCandidateTestFrame(generation: number, delay = 250) {
        if (generation !== this.judgementCandidateTestGeneration || !this.judgementCandidateTestRunning) return;
        this.judgementCandidateTestTimer = setTimeout(
            () => void this.captureJudgementCandidateTestFrame(generation), delay,
        );
    }

    private async captureJudgementCandidateTestFrame(generation: number) {
        if (generation !== this.judgementCandidateTestGeneration || !this.judgementCandidateTestRunning) return;
        if (this.judgementCandidateTestBusy) {
            this.scheduleJudgementCandidateTestFrame(generation, 150); return;
        }
        const video = document.getElementById('judgement-candidate-test-video') as HTMLVideoElement;
        if (!video?.videoWidth || video.readyState < 2 || video.seeking) {
            this.scheduleJudgementCandidateTestFrame(generation, 300); return;
        }
        if (video.ended) { this.stopJudgementCandidateTest(true, false); return; }
        if (video.paused) { this.scheduleJudgementCandidateTestFrame(generation, 250); return; }
        this.judgementCandidateTestBusy = true;
        try {
            const sourceTime = Number(video.currentTime || 0);
            const canvas = document.createElement('canvas');
            const scale = Math.min(1, 640 / video.videoWidth);
            canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
            canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
            const context = canvas.getContext('2d');
            if (!context) throw new Error('동영상 프레임을 읽을 수 없습니다.');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', .8));
            if (!blob) throw new Error('동영상 테스트 프레임을 만들 수 없습니다.');
            const form = new FormData();
            form.append('image', blob, 'judgement-candidate-live.jpg');
            form.append('experiment_id', this.judgementCandidateTestExperimentId);
            const payload = await this.judgementCandidateCall('judgement_candidate_frame', form);
            const code = Number(payload?.code || 500);
            const data = payload?.data || payload || {};
            if (code !== 200) throw new Error(data?.message || '자세 판정 Candidate 추론에 실패했습니다.');
            if (generation !== this.judgementCandidateTestGeneration) return;
            this.judgementCandidateTestFrame = {
                ...(data?.result || {}), source_time_seconds: sourceTime,
            };
            this.judgementCandidateEvaluatedFrameCount += 1;
            this.judgementCandidateTestError = '';
        } catch (error: any) {
            if (generation === this.judgementCandidateTestGeneration) {
                this.judgementCandidateTestError = this.callError(error, '자세 판정 Candidate 추론에 실패했습니다.');
            }
        } finally {
            this.judgementCandidateTestBusy = false;
            if (generation === this.judgementCandidateTestGeneration) {
                await this.service.render();
                this.scheduleJudgementCandidateTestFrame(generation, this.judgementCandidateTestError ? 1200 : 250);
            }
        }
    }

    public judgementCandidateStatusLabel() {
        const status = this.judgementCandidateTestFrame?.status;
        return ({ PASS: '정상 자세', FAIL: '자세 이상', UNCERTAIN: '판단 보류', NOT_EVALUABLE: '판정 불가' } as any)[status]
            || '첫 자세 판정을 준비하고 있습니다.';
    }

    public judgementCandidateConfidenceLabel() {
        const confidence = Number(this.judgementCandidateTestFrame?.confidence);
        return Number.isFinite(confidence) ? `${(confidence * 100).toFixed(1)}%` : '-';
    }

    public async completeJudgementCandidateTest() {
        if (this.judgementCandidateTestPassBusy || this.judgementCandidateEvaluatedFrameCount < 1) return;
        this.stopJudgementCandidateTest(false);
        this.judgementCandidateTestPassBusy = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await this.judgementCandidateCall('judgement_candidate_pass', {
                experiment_id: this.judgementCandidateTestExperimentId,
                evaluated_frame_count: this.judgementCandidateEvaluatedFrameCount,
                last_status: this.judgementCandidateTestFrame?.status || '',
                last_confidence: this.judgementCandidateTestFrame?.confidence ?? '',
            });
            if (code !== 200) throw new Error(data?.message || '자세 판정 동영상 테스트를 완료하지 못했습니다.');
            this.judgementCandidateTestPassed = true;
            this.notice = '동영상 테스트를 완료했습니다. 모델 관리의 테스트 통과 모델에서 운영 적용할 수 있습니다.';
            await this.loadState();
        } catch (error: any) {
            this.errorMessage = this.callError(error, '자세 판정 동영상 테스트를 완료하지 못했습니다.');
        } finally {
            this.judgementCandidateTestPassBusy = false;
            await this.service.render();
        }
    }

    public goToTestedModelManager() {
        this.go('/page.xray/model-manager#tested-models-section');
    }

    public selectProfile(key: string) {
        const profile = this.profile(key);
        if (!profile?.available || profile?.read_only) return;
        this.configuration.profile = key;
        this.configuration.epochs = Number(profile.epochs || 30);
        this.configuration.image_size = ['yolo_camera_dual', 'yolo_pose_retry'].includes(key) ? 640 : key === 'quick' ? 192 : 224;
        this.service.render();
    }

    public canStartOperatingPostureTraining() {
        return Boolean(this.normalityReview()?.trainable)
            && this.splitValid()
            && Boolean(this.profile('operating_posture_classifier')?.available)
            && !this.hasActiveTrainingJob()
            && !this.startBusy
            && !this.saveBusy;
    }

    public async startOperatingPostureTraining() {
        if (!this.canStartOperatingPostureTraining()) return;
        this.configuration.profile = 'operating_posture_classifier';
        this.configuration.epochs = 30;
        this.configuration.image_size = 224;
        await this.saveExperiment();
        if (this.selectedExperiment?.id && this.selectedExperiment?.status !== 'completed') {
            await this.startTraining();
        }
    }

    public canStartReviewedPoseTraining() {
        return this.poseTrainingPrepared
            && this.poseTrainingMediaCount() >= 20
            && this.serverTrainingResources?.start_allowed === true
            && Boolean(this.profile('yolo_pose_retry')?.available)
            && Boolean(this.operatingPoseModel())
            && this.splitValid()
            && Number(this.poseEpochs || 0) >= 1
            && Number(this.poseEpochs || 0) <= 200
            && !this.hasActiveTrainingJob()
            && !this.startBusy
            && !this.saveBusy;
    }

    public async startReviewedPoseTraining() {
        if (!this.canStartReviewedPoseTraining()) return;
        this.startBusy = true;
        this.errorMessage = '';
        this.notice = '';
        await this.service.render();
        const configuration = {
            profile: 'yolo_pose_retry',
            epochs: Number(this.poseEpochs),
            image_size: 640,
            pose_media_mode: this.poseTrainingMediaMode,
            advanced_split: { ...this.configuration.advanced_split },
        };
        try {
            const { code, data } = await this.trainingCall('reviewed_pose_training_start', {
                configuration: JSON.stringify(configuration),
            });
            if (code === 202) {
                this.poseTrainingPrepared = false;
                this.experiments = data?.experiments || this.experiments;
                this.jobs = data?.jobs || this.jobs;
                this.selectedExperiment = data?.item || this.selectedExperiment;
                this.selectedJob = data?.job || this.selectedJob;
                this.notice = data?.started === false
                    ? '동일한 자세 학습 작업이 이미 진행 중입니다.'
                    : `${this.poseTrainingMediaLabel()} 자료로 현재 운영 모델 ${this.displayModelName(this.operatingPoseModel()?.model_id)}의 자세 학습을 등록했습니다.`;
                this.startPolling();
            } else {
                this.errorMessage = data?.message || 'Pose 검수 자료 학습을 시작하지 못했습니다.';
            }
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Pose 검수 자료 학습을 시작하지 못했습니다.');
        }
        this.startBusy = false;
        await this.service.render();
    }

    public poseTrainingButtonLabel() {
        const poseJob = this.selectedExperiment?.configuration?.profile === 'yolo_pose_retry'
            ? this.selectedJob
            : this.jobs.find((job: any) => this.poseExperiments().some((item: any) => item.id === job.experiment_id));
        if (this.poseTrainingPrepared) return '학습하기';
        if (poseJob?.status === 'completed' && !this.poseTrainingPrepared) return '학습 완료';
        if (poseJob?.status === 'failed' || poseJob?.status === 'cancelled') return '다시 준비 필요';
        if (['queued', 'running'].includes(poseJob?.status)) {
            return `학습 중 ${poseJob?.current_epoch || 0}/${poseJob?.total_epoch || this.poseEpochs}`;
        }
        return '학습하기';
    }

    public reviewedPoseTrainingBlockReason() {
        if (!this.profile('yolo_pose_retry')?.available) return this.profile('yolo_pose_retry')?.unavailable_reason || 'Pose 학습 조건을 확인해 주세요.';
        if (!this.operatingPoseModel()) return '업그레이드할 현재 운영 자세 모델을 확인할 수 없습니다.';
        if (!this.poseTrainingPrepared) return '사진만·동영상만·사진+동영상 중 학습 자료를 먼저 선택해 주세요.';
        if (this.poseTrainingMediaCount() < 20) return `${this.poseTrainingMediaLabel()} 검수 좌표가 20장 필요합니다. 현재 ${this.poseTrainingMediaCount()}장입니다.`;
        if (this.hasActiveTrainingJob()) return '다른 학습 작업이 진행 중입니다.';
        if (this.serverTrainingResources?.start_allowed !== true) return this.serverTrainingResources?.message || 'CPU 학습 서버 상태를 확인해 주세요.';
        if (!this.splitValid()) return 'Train/Validation/Test 비율 합계를 100%로 맞춰 주세요.';
        return '';
    }

    public operatingPoseModel() { return this.capabilities?.operating_posture?.pose || null; }

    public displayModelName(value: any, fallback = '현재 운영 모델') {
        const name = String(value || '').trim();
        if (!name) return fallback;
        const yoloIndex = name.toLowerCase().indexOf('yolo');
        return yoloIndex >= 0 ? name.slice(yoloIndex) : name;
    }

    public operatingPoseModelLabel() {
        return this.displayModelName(
            this.operatingPoseModel()?.model_id,
            '현재 운영 Pose 모델',
        );
    }

    public reviewedZipSize() {
        const bytes = Number(this.reviewedDataset?.artifact?.size_bytes || 0);
        return bytes ? `${(bytes / 1024 / 1024 / 1024).toFixed(1)} GB` : '-';
    }

    public poseExperiments() {
        return this.experiments.filter(
            (item: any) => item?.configuration?.profile === 'yolo_pose_retry'
        );
    }

    public completedPoseExperiments() {
        return this.poseExperiments().filter((item: any) => (
            this.jobs.find((job: any) => job.experiment_id === item.id)?.status === 'completed'
        ));
    }

    public poseCandidateExperimentLabel(item: any) {
        const job = this.jobs.find((row: any) => row.experiment_id === item?.id);
        const candidate = job?.job_id ? `pose-${job.job_id}` : item?.id;
        return `${this.displayModelName(candidate, 'Pose Candidate')} · ${this.poseTrainingMediaLabel(item?.configuration?.pose_media_mode || 'all')} · ${this.formatDate(item?.created_at)}`;
    }

    public async selectPoseCandidateExperiment(experimentId: string) {
        const item = this.completedPoseExperiments().find((row: any) => row.id === experimentId);
        if (!item) return;
        this.stopPoseCandidateRealtime(false);
        await this.selectExperiment(item);
        const input = document.getElementById('pose-candidate-video-file') as HTMLInputElement;
        if (input) input.value = '';
    }

    public poseCandidateVideoCanRun() {
        return Boolean(this.poseCandidateVideoFile)
            && this.selectedExperiment?.configuration?.profile === 'yolo_pose_retry'
            && this.selectedJob?.status === 'completed'
            && !this.poseCandidateVideoBusy;
    }

    public async onPoseCandidateVideo(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0] || null;
        this.clearPoseCandidateVideo();
        this.poseCandidateVideoFile = file;
        if (file) this.poseCandidateVideoUrl = URL.createObjectURL(file);
        await this.service.render();
    }

    public async togglePoseCandidateRealtime() {
        if (this.poseCandidateRealtimeOn) {
            this.stopPoseCandidateRealtime();
            return;
        }
        if (this.selectedExperiment?.configuration?.profile !== 'yolo_pose_retry'
            || this.selectedJob?.status !== 'completed') {
            this.poseCandidateRealtimeError = '먼저 학습 완료된 자세 Candidate를 선택해 주세요.';
            await this.service.render();
            return;
        }
        if (!this.poseCandidateVideoFile || !this.poseCandidateVideoUrl) {
            this.poseCandidateRealtimeError = '먼저 테스트할 동영상을 선택해 주세요.';
            await this.service.render();
            return;
        }
        this.poseCandidateRealtimeError = '';
        this.poseCandidateRealtimeOn = true;
        this.poseCandidateRealtimeFrame = null;
        this.poseCandidateRealtimeFramesProcessed = 0;
        this.poseCandidateRealtimeTrackingId = (
            (window.crypto as any)?.randomUUID?.()
            || `pose-candidate-${Date.now()}-${Math.random().toString(16).slice(2)}`
        );
        const generation = ++this.poseCandidateRealtimeGeneration;
        await this.service.render();
        const video = document.getElementById(
            'pose-candidate-test-video'
        ) as HTMLVideoElement;
        if (!video) {
            this.poseCandidateRealtimeError = '선택한 동영상 플레이어를 열 수 없습니다.';
            this.stopPoseCandidateRealtime();
            return;
        }
        try {
            if (video.ended) video.currentTime = 0;
            await video.play();
        } catch (_error) {
            this.poseCandidateRealtimeError = '동영상을 재생할 수 없습니다. 파일 형식을 확인해 주세요.';
            this.stopPoseCandidateRealtime();
            return;
        }
        this.schedulePoseCandidateRealtimeFrame(generation, 0);
    }

    public stopPoseCandidateRealtime(render = true, pauseVideo = true) {
        this.poseCandidateRealtimeGeneration += 1;
        if (this.poseCandidateRealtimeTimer) {
            clearTimeout(this.poseCandidateRealtimeTimer);
            this.poseCandidateRealtimeTimer = null;
        }
        if (pauseVideo) {
            const video = document.getElementById(
                'pose-candidate-test-video'
            ) as HTMLVideoElement;
            if (video && !video.paused) video.pause();
        }
        this.poseCandidateRealtimeOn = false;
        this.poseCandidateRealtimeBusy = false;
        if (render) void this.service.render();
    }

    public onPoseCandidateRealtimeSeeked() {
        if (!this.poseCandidateRealtimeOn) return;
        this.poseCandidateRealtimeFrame = null;
        this.poseCandidateRealtimeTrackingId = (
            (window.crypto as any)?.randomUUID?.()
            || `pose-candidate-${Date.now()}-${Math.random().toString(16).slice(2)}`
        );
        const generation = ++this.poseCandidateRealtimeGeneration;
        this.schedulePoseCandidateRealtimeFrame(generation, 0);
    }

    public onPoseCandidateRealtimeEnded() {
        if (this.poseCandidateRealtimeOn) {
            this.stopPoseCandidateRealtime(true, false);
        }
    }

    private schedulePoseCandidateRealtimeFrame(generation: number, delay = 150) {
        if (
            generation !== this.poseCandidateRealtimeGeneration
            || !this.poseCandidateRealtimeOn
        ) return;
        this.poseCandidateRealtimeTimer = setTimeout(
            () => void this.capturePoseCandidateRealtimeFrame(generation),
            delay,
        );
    }

    private async capturePoseCandidateRealtimeFrame(generation: number) {
        if (
            generation !== this.poseCandidateRealtimeGeneration
            || !this.poseCandidateRealtimeOn
        ) return;
        if (this.poseCandidateRealtimeBusy) {
            this.schedulePoseCandidateRealtimeFrame(generation, 100);
            return;
        }
        const video = document.getElementById(
            'pose-candidate-test-video'
        ) as HTMLVideoElement;
        if (!video?.videoWidth || video.readyState < 2) {
            this.schedulePoseCandidateRealtimeFrame(generation, 250);
            return;
        }
        if (video.ended) {
            this.stopPoseCandidateRealtime(true, false);
            return;
        }
        if (video.paused || video.seeking) {
            this.schedulePoseCandidateRealtimeFrame(generation, 200);
            return;
        }
        this.poseCandidateRealtimeBusy = true;
        try {
            const sourceTime = Number(video.currentTime || 0);
            const canvas = document.createElement('canvas');
            const scale = Math.min(1, 640 / video.videoWidth);
            canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
            canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
            const context = canvas.getContext('2d');
            if (!context) throw new Error('동영상 프레임을 읽을 수 없습니다.');
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(
                resolve, 'image/jpeg', 0.78,
            ));
            if (!blob) throw new Error('동영상 프레임을 만들 수 없습니다.');
            const form = new FormData();
            form.append('image', blob, 'pose-candidate-live.jpg');
            form.append('job_id', this.selectedJob?.job_id || '');
            form.append('tracking_id', this.poseCandidateRealtimeTrackingId);
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), 90000);
            let response: Response | null = null;
            let payload: any = null;
            try {
                response = await fetch(
                    '/wiz/api/page.xray.experiments/test_pose_candidate_realtime_frame_v1',
                    {
                        method: 'POST', body: form, credentials: 'same-origin',
                        signal: controller.signal,
                    },
                );
                payload = await response.json();
            } finally {
                clearTimeout(timeout);
            }
            const code = Number(payload?.code || response?.status || 500);
            const data = payload?.data || payload || {};
            if (code !== 200) throw new Error(
                data?.message || `Pose Candidate 실시간 추적에 실패했습니다. (${code})`
            );
            if (generation !== this.poseCandidateRealtimeGeneration) return;
            const currentTime = Number(video.currentTime || 0);
            const stale = !video.paused && Math.abs(currentTime - sourceTime) > .35;
            if (stale) {
                this.poseCandidateRealtimeFrame = null;
                return;
            }
            this.poseCandidateRealtimeFrame = data?.result
                ? { ...data.result, source_time_seconds: sourceTime }
                : null;
            this.poseCandidateRealtimeFramesProcessed += 1;
            this.poseCandidateRealtimeError = '';
        } catch (error: any) {
            if (generation === this.poseCandidateRealtimeGeneration) {
                this.poseCandidateRealtimeError = this.callError(
                    error, 'Pose Candidate 실시간 추적에 실패했습니다.'
                );
            }
        } finally {
            this.poseCandidateRealtimeBusy = false;
            if (generation === this.poseCandidateRealtimeGeneration) {
                await this.service.render();
                this.schedulePoseCandidateRealtimeFrame(
                    generation,
                    this.poseCandidateRealtimeError ? 1200 : 0,
                );
            }
        }
    }

    public poseCandidateRealtimeStatusLabel() {
        if (!this.poseCandidateRealtimeFrame) return '첫 관절 추론을 준비하고 있습니다.';
        return this.poseCandidateRealtimeFrame.detected
            ? '현재 프레임 자세 관절 추적 중'
            : '현재 프레임 자세 미검출';
    }

    public poseCandidatePostureStatusLabel() {
        const status = this.poseCandidateRealtimeFrame?.posture_judgement?.finalStatus;
        return ({
            NORMAL: '정상 자세',
            BORDERLINE: '경계 · 다시 확인',
            CORRECTION_REQUIRED: '자세 교정 필요',
            UNAVAILABLE: '자세 판정 불가',
        } as any)[status] || '자세 판정 준비 중';
    }

    public poseCandidatePostureStatusClass() {
        const status = this.poseCandidateRealtimeFrame?.posture_judgement?.finalStatus;
        if (status === 'NORMAL') return 'border-emerald-300 bg-emerald-50 text-emerald-900';
        if (status === 'CORRECTION_REQUIRED') return 'border-red-300 bg-red-50 text-red-900';
        if (status === 'BORDERLINE') return 'border-amber-300 bg-amber-50 text-amber-900';
        return 'border-slate-300 bg-slate-50 text-slate-700';
    }

    public poseCandidatePostureIssues() {
        return (this.poseCandidateRealtimeFrame?.posture_judgement?.classes || [])
            .filter((item: any) => item?.state === 'abnormal' || item?.state === 'suspected')
            .sort((a: any, b: any) => Number(a?.class_index || 99) - Number(b?.class_index || 99))
            .slice(0, 4);
    }

    public async runPoseCandidateVideoTest() {
        if (!this.poseCandidateVideoCanRun()) return;
        this.poseCandidateVideoBusy = true;
        this.errorMessage = '';
        this.notice = '';
        await this.service.render();
        try {
            const form = new FormData();
            form.append('file', this.poseCandidateVideoFile as File, (this.poseCandidateVideoFile as File).name);
            form.append('job_id', this.selectedJob.job_id);
            const { code, data } = await wiz.call('test_pose_candidate_video_v1', form, {
                processData: false, contentType: false,
            });
            if (code !== 200) throw new Error(data?.message || 'Pose Candidate 동영상 시험이 실패했습니다.');
            this.poseCandidateVideoResult = data?.result || null;
            const frames = this.poseCandidateVideoResult?.frames || [];
            this.poseCandidateVideoFrame = frames.find((row: any) => row?.detected) || frames[0] || null;
            this.notice = 'Pose Candidate 동영상 시험을 완료했습니다. 운영 자세 모델은 변경하지 않았습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Pose Candidate 동영상 시험이 실패했습니다.');
        }
        this.poseCandidateVideoBusy = false;
        await this.service.render();
        const video = document.getElementById('pose-candidate-test-video') as HTMLVideoElement;
        if (video && this.poseCandidateVideoFrame) {
            video.currentTime = Number(this.poseCandidateVideoFrame.timestamp_seconds || 0);
        }
    }

    public onPoseCandidateVideoTimeUpdate(event: Event) {
        const video = event.target as HTMLVideoElement;
        const frames = this.poseCandidateVideoResult?.frames || [];
        if (!frames.length) return;
        const nearest = frames.reduce((best: any, row: any) => (
            Math.abs(Number(row.timestamp_seconds || 0) - video.currentTime)
                < Math.abs(Number(best.timestamp_seconds || 0) - video.currentTime) ? row : best
        ), frames[0]);
        if (nearest?.frame_index !== this.poseCandidateVideoFrame?.frame_index) {
            this.poseCandidateVideoFrame = nearest;
            this.service.render();
        }
    }

    public selectPoseCandidateVideoFrame(frame: any) {
        this.poseCandidateVideoFrame = frame;
        const video = document.getElementById('pose-candidate-test-video') as HTMLVideoElement;
        if (video) video.currentTime = Number(frame?.timestamp_seconds || 0);
        this.service.render();
    }

    public poseCandidateVideoPoints() {
        return (this.poseCandidateRealtimeFrame?.keypoints || []).filter(
            (point: any) => POSE_TEST_VISIBLE_IDS.has(Number(point?.id))
                && point?.visibility !== 'not_labeled'
                && Number(point?.confidence || 0) >= 0.12
        );
    }

    public poseCandidateVideoEdges() {
        const points: any = {};
        this.poseCandidateVideoPoints().forEach((point: any) => { points[Number(point.id)] = point; });
        return POSE_TEST_EDGES.map(([from, to]) => ({ from: points[from], to: points[to] }))
            .filter((edge: any) => edge.from && edge.to);
    }

    public poseCandidateTorsoPolygonPoints() {
        const points: any = {};
        this.poseCandidateVideoPoints().forEach((point: any) => { points[Number(point.id)] = point; });
        const torso = [points[11], points[12], points[24], points[23]];
        if (torso.some((point: any) => !point)) return '';
        return torso.map((point: any) => `${point.x * 1000},${point.y * 1000}`).join(' ');
    }

    public clearPoseCandidateVideo() {
        this.stopPoseCandidateRealtime(false);
        if (this.poseCandidateVideoUrl) URL.revokeObjectURL(this.poseCandidateVideoUrl);
        this.poseCandidateVideoUrl = '';
        this.poseCandidateVideoFile = null;
        this.poseCandidateVideoResult = null;
        this.poseCandidateVideoFrame = null;
        this.poseCandidateRealtimeFrame = null;
        this.poseCandidateRealtimeError = '';
        this.poseCandidateRealtimeFramesProcessed = 0;
    }

    public scrollToPoseResults() {
        document.getElementById('pose-training-results')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public isRecommendedPipeline() { return this.configuration.profile === 'yolo_camera_dual'; }

    public splitTotal() {
        const split = this.configuration.advanced_split;
        return Number(split.train || 0) + Number(split.validation || 0) + Number(split.test || 0);
    }

    public splitValid() {
        const split = this.configuration.advanced_split;
        return this.splitTotal() === 100 && ['train', 'validation', 'test'].every((key) => Number(split[key]) > 0);
    }

    public canSaveRequest() {
        return Boolean(this.readiness?.ready) && this.splitValid() && Boolean(this.profile(this.configuration.profile)?.available);
    }

    public canStartTraining() {
        return Boolean(this.selectedExperiment?.id)
            && !['queued', 'running'].includes(this.selectedJob?.status)
            && this.selectedExperiment?.status !== 'completed';
    }

    public async auditDataset() {
        this.loading = true; this.notice = ''; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('audit');
            if (code === 200) {
                this.summary = data?.summary || this.summary;
                this.readiness = data?.readiness || this.readiness;
                this.notice = '데이터 감사를 완료했습니다.';
            } else this.errorMessage = data?.message || '데이터 감사를 완료하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '데이터 감사를 완료하지 못했습니다.'); }
        this.loading = false; await this.service.render();
    }

    public async importServerDataset() {
        this.importBusy = true; this.errorMessage = ''; this.notice = ''; await this.service.render();
        try {
            const form = new FormData(); form.append('mode', 'server');
            const { code, data } = await this.trainingCall('dataset_import', form, { processData: false, contentType: false });
            if (code === 200) {
                this.summary = data?.summary || this.summary;
                this.notice = '서버 dataset/pass·fail을 확인해 중복 없이 연결했습니다.';
            } else this.errorMessage = data?.message || '서버 데이터셋을 불러오지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '서버 데이터셋을 불러오지 못했습니다.'); }
        this.importBusy = false; await this.loadState(true);
    }

    public onFiles(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = Array.from(input.files || []);
        this.clearPendingPreviews();
        this.pendingFiles = files.slice(0, 1000).map((file: any) => ({
            file,
            relativePath: file.webkitRelativePath || file.name,
            url: file.type?.startsWith('image/') ? URL.createObjectURL(file) : ''
        }));
        this.importResult = null;
        this.service.render();
    }

    public async uploadPending() {
        if (!this.pendingFiles.length || this.importBusy) return;
        this.importBusy = true; this.errorMessage = ''; this.notice = '';
        const totals = { total: 0, imported: 0, duplicates: 0, review_required: 0, excluded: 0 };
        await this.service.render();
        for (const item of this.pendingFiles) {
            try {
                const form = new FormData();
                form.append('file', item.file, item.file.name || 'upload');
                form.append('label', this.importLabel);
                form.append('relative_path', item.relativePath);
                const { code, data } = await this.trainingCall('dataset_import', form, { processData: false, contentType: false });
                if (code === 201) {
                    const result = data?.result || {};
                    if (Array.isArray(result.items)) {
                        for (const key of Object.keys(totals)) totals[key as keyof typeof totals] += Number(result[key] || 0);
                    } else {
                        totals.total += 1;
                        const status = result.status;
                        if (status === 'imported') totals.imported += 1;
                        else if (status === 'duplicate') totals.duplicates += 1;
                        else if (status === 'review_required') totals.review_required += 1;
                        else totals.excluded += 1;
                    }
                    this.summary = data?.summary || this.summary;
                } else totals.excluded += 1;
            } catch (_) { totals.excluded += 1; }
        }
        this.importResult = totals;
        this.notice = `가져오기 완료: 추가 ${totals.imported}, 중복 ${totals.duplicates}, 검수 필요 ${totals.review_required}, 제외 ${totals.excluded}`;
        this.importBusy = false; this.clearPendingPreviews(); this.pendingFiles = [];
        await this.loadState(true);
    }

    public async saveExperiment() {
        if (!this.canSaveRequest() || this.saveBusy) return;
        this.saveBusy = true; this.errorMessage = ''; this.notice = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('experiment_save', {
                configuration: JSON.stringify(this.configuration)
            });
            if (code === 201) {
                this.experiments = data?.experiments || [data?.item];
                this.selectedExperiment = data?.item;
                this.selectedJob = null;
                this.notice = '설정과 데이터 snapshot을 저장했습니다. 아직 학습은 시작하지 않았습니다.';
            } else this.errorMessage = data?.message || '실험 요청을 저장하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '실험 요청을 저장하지 못했습니다.'); }
        this.saveBusy = false; await this.service.render();
    }

    public async startTraining() {
        if (!this.canStartTraining() || this.startBusy) return;
        this.startBusy = true; this.errorMessage = ''; this.notice = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('experiment_start', {
                experiment_id: this.selectedExperiment.id
            });
            if (code === 202) {
                this.selectedJob = data?.job;
                this.notice = '학습 작업이 queue에 등록되었습니다.';
                this.startPolling();
            } else this.errorMessage = data?.message || '학습을 시작하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '학습을 시작하지 못했습니다.'); }
        this.startBusy = false; await this.service.render();
    }

    public async startRecommendedGuideTraining() {
        if (!this.canGuideTraining() || this.startBusy || this.saveBusy) return;
        this.configuration.profile = 'yolo_camera_dual';
        this.configuration.epochs = 50;
        this.configuration.image_size = 640;
        await this.saveExperiment();
        if (this.selectedExperiment?.id && this.selectedExperiment?.status !== 'completed') {
            await this.startTraining();
        }
    }

    public isYoloPoseResult() {
        return ['yolo_camera_dual', 'yolo_pose_retry'].includes(String(this.metrics?.model_family || ''));
    }

    public canMarkPoseCandidateTestPassed() {
        return this.selectedExperiment?.configuration?.profile === 'yolo_pose_retry'
            && this.selectedJob?.status === 'completed'
            && this.metrics?.evaluation_status === 'EVALUATED'
            && Number(this.metrics?.pose?.map50 || 0) > 0
            && Number(this.metrics?.label_report?.phash_group_leakage_count || 0) === 0
            && !this.poseCandidateTestPassBusy
            && !this.poseCandidateTestPassed;
    }

    public async markPoseCandidateTestPassed() {
        if (!this.canMarkPoseCandidateTestPassed()) return;
        if (!window.confirm(
            '이 Pose Candidate의 고정 Test 결과와 그룹 누수 0건을 확인했나요?\n\n통과 목록에만 등록하며 운영 모델은 자동 변경하지 않습니다.'
        )) return;
        this.poseCandidateTestPassBusy = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('mark_pose_candidate_test_pass_v1', {
                job_id: this.selectedJob.job_id,
            });
            if (code !== 200) throw new Error(data?.message || 'Pose 테스트 통과를 등록하지 못했습니다.');
            this.poseCandidateTestPassed = true;
            this.notice = 'Pose Candidate를 테스트 통과 모델로 등록했습니다. 모델 관리에서 운영 변경할 수 있습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, 'Pose 테스트 통과를 등록하지 못했습니다.');
        } finally {
            this.poseCandidateTestPassBusy = false;
            await this.service.render();
        }
    }

    public canRetryYoloPose() {
        return this.isYoloPoseResult()
            && Number(this.metrics?.pose?.map50 || 0) < 0.5
            && Boolean(this.profile('yolo_pose_retry')?.available)
            && !this.hasActiveTrainingJob()
            && !this.startBusy
            && !this.saveBusy;
    }

    public async startYoloPoseRetry() {
        if (!this.canRetryYoloPose()) return;
        this.configuration.profile = 'yolo_pose_retry';
        this.configuration.epochs = 50;
        this.configuration.image_size = 640;
        await this.saveExperiment();
        if (this.selectedExperiment?.id && this.selectedExperiment?.status !== 'completed') {
            await this.startTraining();
        }
    }

    public async cancelTraining() {
        if (!this.selectedJob?.job_id || this.actionBusy) return;
        this.actionBusy = true; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('job_cancel', { job_id: this.selectedJob.job_id });
            if (code === 200) {
                this.selectedJob = data?.job || this.selectedJob;
                this.notice = '중단 요청을 저장했습니다. 현재 checkpoint는 유지됩니다.';
            } else this.errorMessage = data?.message || '작업을 중단하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '작업을 중단하지 못했습니다.'); }
        this.actionBusy = false; await this.service.render();
    }

    public async selectExperiment(item: any) {
        if (item?.configuration?.profile !== 'yolo_pose_retry') return;
        this.clearPoseCandidateVideo();
        this.selectedExperiment = item;
        this.selectedJob = this.jobs.find((job) => job.experiment_id === item.id) || null;
        this.poseCandidateTestPassed = false;
        this.metrics = null; this.evaluationSummary = null; this.artifacts = [];
        if (this.selectedJob?.status === 'completed') await this.loadResults();
        if (['queued', 'running'].includes(this.selectedJob?.status)) this.startPolling();
        else this.stopPolling();
        await this.service.render();
    }

    private startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(() => this.pollJob(), 2000);
        this.pollJob();
    }

    private stopPolling() {
        if (this.pollTimer) clearInterval(this.pollTimer);
        this.pollTimer = null;
    }

    public async pollJob() {
        if (!this.selectedJob?.job_id) return;
        try {
            const { code, data } = await this.trainingCall('job_status', { job_id: this.selectedJob.job_id });
            if (code === 200) {
                this.selectedJob = data?.job || this.selectedJob;
                const index = this.jobs.findIndex((item) => item.job_id === this.selectedJob.job_id);
                if (index >= 0) this.jobs[index] = this.selectedJob;
                if (['completed', 'failed', 'cancelled'].includes(this.selectedJob.status)) {
                    this.stopPolling();
                    await this.loadState(true);
                    if (this.selectedJob.status === 'completed') await this.loadResults();
                }
            }
        } catch (_) { }
        await this.service.render();
    }

    public async loadResults() {
        if (!this.selectedExperiment?.id) return;
        try {
            const [metrics, artifacts] = await Promise.all([
                this.trainingCall('metrics', { experiment_id: this.selectedExperiment.id }),
                this.trainingCall('artifacts', { experiment_id: this.selectedExperiment.id })
            ]);
            this.metrics = metrics.data?.metrics || null;
            this.evaluationSummary = metrics.data?.evaluation_summary || null;
            this.selectedExperiment.comparison = metrics.data?.comparison || null;
            this.artifacts = artifacts.data?.artifacts || [];
        } catch (_) { }
        await this.service.render();
    }

    public artifactUrl(name: string) {
        if (!this.selectedJob?.job_id) return '';
        return '/wiz/api/page.xray.experiments/load_paper_state_v2?training_action=artifact_file&job_id='
            + encodeURIComponent(this.selectedJob.job_id) + '&name=' + encodeURIComponent(name);
    }

    public artifactExists(name: string) { return this.artifacts.some((item) => item.name === name); }

    public async compareLegacy() {
        if (!this.selectedExperiment?.id || this.actionBusy) return;
        this.actionBusy = true; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('legacy_compare', { experiment_id: this.selectedExperiment.id });
            if (code === 200) {
                this.selectedExperiment.comparison = data?.comparison;
                this.notice = data?.comparison?.comparison_status === 'EVALUATED'
                    ? '동일 test 비교를 완료했습니다.'
                    : '기존 예측이 없어 비교 평가 기록을 만들지 않았습니다.';
            } else this.errorMessage = data?.message || '기존 모델 비교를 실행하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '기존 모델 비교를 실행하지 못했습니다.'); }
        this.actionBusy = false; await this.service.render();
    }

    public async registerCandidate() {
        if (!this.selectedExperiment?.id || this.actionBusy) return;
        this.actionBusy = true; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('candidate_register', { experiment_id: this.selectedExperiment.id });
            if (code === 201) {
                this.notice = 'immutable 후보 모델로 등록했습니다. 기본 권장은 shadow 적용입니다.';
                await this.loadState(true);
            } else this.errorMessage = data?.message || '후보 모델을 등록하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '후보 모델을 등록하지 못했습니다.'); }
        this.actionBusy = false; await this.service.render();
    }

    public async activateModel(modelId: string, mode: 'shadow' | 'hybrid' | 'trained' | 'inactive') {
        if (!modelId || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('model_activate', {
                model_id: modelId, mode, admin_confirmed: false
            });
            if (code === 200) {
                this.notice = mode === 'shadow' ? '후보 모델을 shadow로 적용했습니다. 운영 판정은 legacy를 유지합니다.' : '모델 적용 상태를 변경했습니다.';
                await this.loadState(true);
            } else this.errorMessage = data?.message || '모델 적용 상태를 변경하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '모델 적용 상태를 변경하지 못했습니다.'); }
        this.actionBusy = false; await this.service.render();
    }

    public async rollbackModel() {
        if (this.actionBusy) return;
        this.actionBusy = true; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('model_rollback');
            if (code === 200) {
                this.notice = '이전 후보 버전 또는 legacy 상태로 rollback했습니다.';
                await this.loadState(true);
            } else this.errorMessage = data?.message || 'rollback하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, 'rollback하지 못했습니다.'); }
        this.actionBusy = false; await this.service.render();
    }

    public yoloValidationChecked(key: string) {
        return Boolean(this.yoloPromotion?.checks?.[key]);
    }

    public async setYoloOperatingValidation(key: string, checked: boolean) {
        if (!key || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('yolo_operating_validation', {
                changes: { [key]: Boolean(checked) }
            });
            if (code === 200) {
                this.yoloPromotion = data?.yolo_promotion || this.yoloPromotion;
                this.notice = '실제 촬영 검증 상태를 저장했습니다.';
            } else this.errorMessage = data?.message || '실제 촬영 검증 상태를 저장하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '실제 촬영 검증 상태를 저장하지 못했습니다.');
        }
        this.actionBusy = false; await this.service.render();
    }

    public async promoteYoloOperatingModel() {
        if (!this.yoloPromotion?.promotion_allowed || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('yolo_operating_promote', {
                admin_confirmed: false
            });
            if (code === 200) {
                this.yoloPromotion = data?.yolo_promotion || this.yoloPromotion;
                this.notice = 'YOLO Pose+Bucky를 운영 모델로 등록했습니다.';
                await this.loadState(true);
            } else this.errorMessage = data?.message || '운영 모델로 등록하지 못했습니다.';
        } catch (error: any) {
            this.errorMessage = this.callError(error, '운영 모델로 등록하지 못했습니다.');
        }
        this.actionBusy = false; await this.service.render();
    }

    public async generateGroups() {
        if (this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('groups');
            if (code === 200) {
                this.metadata = { ...this.metadata, ...(data?.groups || {}) };
                this.notice = '후보 그룹을 생성했습니다. 자동 결과는 정답이 아니며 사람 검수가 필요합니다.';
            } else this.errorMessage = data?.message || '후보 그룹을 생성하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '후보 그룹을 생성하지 못했습니다.'); }
        this.actionBusy = false; await this.loadState(true);
    }

    public async reviewGroup(group: any, decision: 'same_person' | 'same_session' | 'different_person' | 'hold') {
        if (!group?.candidate_group_id || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('group_review', {
                candidate_group_id: group.candidate_group_id, decision
            });
            if (code === 200) {
                this.metadata = data?.metadata || this.metadata;
                this.notice = '후보 그룹 검수 결과를 저장했습니다.';
            } else this.errorMessage = data?.message || '그룹 검수 결과를 저장하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '그룹 검수 결과를 저장하지 못했습니다.'); }
        this.actionBusy = false; await this.loadState(true);
    }

    public async saveMetadata(item: any) {
        if (!item?.image_path || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const changes = {
                label: item.label, person_id: item.person_id, session_id: item.session_id,
                failure_reason: item.failure_reason, reviewed: Boolean(item.reviewed)
            };
            const { code, data } = await this.trainingCall('metadata_update', {
                image_path: item.image_path, changes: JSON.stringify(changes)
            });
            if (code === 200) {
                this.metadata = data?.metadata || this.metadata;
                this.notice = '이미지 메타데이터를 저장했습니다.';
            } else this.errorMessage = data?.message || '메타데이터를 저장하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, '메타데이터를 저장하지 못했습니다.'); }
        this.actionBusy = false; await this.loadState(true);
    }

    public async importMetadataCsv(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const form = new FormData(); form.append('file', file, file.name);
            const { code, data } = await this.trainingCall('metadata_import', form, { processData: false, contentType: false });
            if (code === 200) {
                this.notice = `CSV 반영 완료: ${data?.result?.updated || 0}건, 제외 ${data?.result?.ignored || 0}건`;
            } else this.errorMessage = data?.message || 'CSV를 가져오지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, 'CSV를 가져오지 못했습니다.'); }
        input.value = ''; this.actionBusy = false; await this.loadState(true);
    }

    public exportMetadataCsv() {
        window.location.href = '/wiz/api/page.xray.experiments/load_paper_state_v2?training_action=metadata_export';
    }

    public onExternalFile(event: Event) {
        const input = event.target as HTMLInputElement;
        this.externalFile = input.files?.[0] || null;
    }

    public async importExternalTest() {
        if (!this.externalFile || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const form = new FormData();
            form.append('file', this.externalFile, this.externalFile.name);
            form.append('label', this.externalLabel);
            const { code, data } = await this.trainingCall('external_import', form, { processData: false, contentType: false });
            if (code === 201) {
                this.metadata.external_test = data?.external_test;
                this.notice = 'external_test에 등록했습니다. 최종 평가 외 사용은 차단됩니다.';
                this.externalFile = null;
            } else this.errorMessage = data?.message || 'external_test를 등록하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, 'external_test를 등록하지 못했습니다.'); }
        this.actionBusy = false; await this.loadState(true);
    }

    public async evaluateExternalTest() {
        if (!this.selectedExperiment?.id || !this.metadata?.external_test?.count || this.actionBusy) return;
        this.actionBusy = true; this.errorMessage = ''; await this.service.render();
        try {
            const { code, data } = await this.trainingCall('external_evaluate', { experiment_id: this.selectedExperiment.id });
            if (code === 200) {
                this.externalMetrics = data?.metrics;
                this.notice = 'external_test 최종 평가를 완료했습니다.';
            } else this.errorMessage = data?.message || 'external_test 평가를 완료하지 못했습니다.';
        } catch (error: any) { this.errorMessage = this.callError(error, 'external_test 평가를 완료하지 못했습니다.'); }
        this.actionBusy = false; await this.service.render();
    }

    public failureReasons() {
        return ['', 'rotation', 'center_offset', 'shoulder_asymmetry', 'arm_position', 'hand_overlap', 'detector_distance', 'not_ready', 'detector_not_visible', 'other'];
    }

    public metric(name: string, digits = 3) {
        const value = this.metrics?.[name];
        if (value === null || value === undefined || !Number.isFinite(Number(value))) return '평가 기록 없음';
        return Number(value).toFixed(digits);
    }

    public percentMetric(value: any, digits = 1) {
        const number = Number(value);
        return Number.isFinite(number) ? `${(number * 100).toFixed(digits)}%` : '평가 기록 없음';
    }

    public plainEvaluationVerdict() {
        const balanced = Number(this.metrics?.balanced_accuracy || 0);
        const falsePass = Number(this.metrics?.false_pass_count || 0);
        if (balanced >= 0.9 && falsePass === 0) return '전체 판정 양호';
        if (balanced >= 0.8 && falsePass <= 1) return '사용 전 보완 권장';
        return '추가 학습 필요';
    }

    public hasNoFalsePass() {
        return Number(this.metrics?.false_pass_count || 0) === 0;
    }

    public abnormalFoundCount() {
        return Number(this.metrics?.class_metrics?.fail?.support || 0);
    }

    public abnormalMissedCount() {
        return Number(this.metrics?.false_pass_count || 0);
    }

    public normalFoundCount() {
        return Number(this.metrics?.class_metrics?.pass?.support || 0);
    }

    public normalCorrectCount() {
        return Number(this.metrics?.confusion_matrix?.[0]?.[0] || 0);
    }

    public postureReasonResults() {
        const labels: any = {
            SHOULDER_DETECTOR_RELATION: '1. 어깨·디텍터 범위 이상',
            SPINE_CENTER_ALIGNMENT: '2. 몸 치우침·척추 중심 이탈',
            UPPER_DETECTOR_CHIN_CONTACT: '3. 상단·턱·밀착 관계 이상',
            LOWER_DETECTOR_CHEST_CROP: '4. 하단·흉부 잘림',
        };
        const source = this.metrics?.posture_reasons || {};
        return Object.keys(labels).map((code) => {
            const row = source?.[code] || {};
            const total = Number(row?.class_metrics?.fail?.support || 0);
            const missed = Number(row?.false_pass_count || 0);
            return {
                code,
                label: labels[code],
                recall: Number(row?.recall || 0),
                total,
                found: Math.max(0, total - missed),
            };
        });
    }

    public nestedMetric(group: string, name: string, digits = 3) {
        const value = this.metrics?.[group]?.[name];
        if (value === null || value === undefined || !Number.isFinite(Number(value))) return '평가 기록 없음';
        return Number(value).toFixed(digits);
    }

    public poseEvaluation() { return this.evaluationSummary?.pose || {}; }
    public buckyEvaluation() { return this.evaluationSummary?.bucky || {}; }
    public buckyDisplayEvaluation() { return this.buckyEvaluation()?.display_evaluation || null; }
    public evaluationValue(value: any, digits = 3) {
        return value === null || value === undefined || !Number.isFinite(Number(value))
            ? '평가 기록 없음'
            : Number(value).toFixed(digits);
    }
    public evaluationSourceLabel(source: string) {
        return ({
            CURRENT_RUN: '이번 실행',
            EXISTING_MODEL_EVALUATION: '기존 모델 평가',
            IMPORTED_METRICS: '가져온 평가 기록',
            NOT_AVAILABLE: '평가 기록 없음',
        } as any)[source] || '평가 기록 없음';
    }
    public currentRunEvaluationLabel(status: string) {
        return status === 'EVALUATED' ? '평가 완료' : '이번 실행 미평가';
    }
    public comparisonStatusLabel(status: string) {
        return status === 'EVALUATED' ? '평가 완료' : '평가 기록 없음';
    }

    public statusLabel(status: string) {
        return ({ requested: '요청 저장됨', queued: '대기', running: '진행 중', completed: '완료', failed: '실패', cancelled: '중단됨' } as any)[status] || status || '-';
    }

    public stageLabel(stage: string) {
        return ({ queued:'대기',dataset_audit:'데이터 감사',dataset_split:'데이터 분할',training_prepare:'학습 준비',weight_import:'공식 Pose 가중치 준비',feature_extraction:'운영 Pose·Bucky 특징 추출',training:'Epoch 학습',training_pose:'자세 스켈레톤 학습',training_detector:'Bucky 사각형 학습',validation:'Validation',test_evaluation:'Test 평가',legacy_comparison:'현재 방식과 비교',result_save:'결과 저장',completed:'완료',failed:'실패',cancelled:'중단' } as any)[stage] || stage || '-';
    }

    public formatSeconds(value: any) {
        const seconds = Math.max(0, Number(value || 0));
        if (!Number.isFinite(seconds)) return '-';
        const minutes = Math.floor(seconds / 60);
        return minutes ? `${minutes}분 ${Math.round(seconds % 60)}초` : `${Math.round(seconds)}초`;
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? value : date.toLocaleString('ko-KR');
    }

    public currentCandidate() {
        const id = this.selectedExperiment?.deployment?.model_id;
        return this.candidateModels.find((item) => item.model_id === id) || null;
    }

    public liveReview() { return this.batchSummary?.live_review || {}; }
    public passAudit() { return this.liveReview()?.pass_audit || this.batchSummary?.assistant?.active_learning?.pass_audit || {}; }
    public passAuditTarget() { return Number(this.passAudit()?.target_count || 0); }
    public passAuditCompleted() { return Number(this.passAudit()?.reviewed_count || 0); }
    public passAuditRemaining() { return Math.max(0, Number(this.passAudit()?.remaining_count ?? (this.passAuditTarget() - this.passAuditCompleted()))); }
    public humanFullPassCount() { return Number(this.liveReview()?.human_pass_types?.HUMAN_FULL_PASS || 0); }
    public humanVisualPassCount() { return Number(this.liveReview()?.human_pass_types?.HUMAN_VISUAL_PASS_CONTACT_UNVERIFIED || 0); }
    public humanPassCount() { return Number(this.liveReview()?.human_pass_types?.HUMAN_PASS || (this.humanFullPassCount() + this.humanVisualPassCount())); }
    public humanResultCount(source: string) { return Number(this.liveReview()?.human_result_counts?.[source] || 0); }
    public fourItemPassCandidateCount() { return Number(this.liveReview()?.legacy_four_item_pass_candidates || 0); }
    public itemReviewCount(code: string) { return Number(this.liveReview()?.item_review_counts?.[code]?.reviewed_count || 0); }
    public verifiedNormalCount() { return Number(this.liveReview()?.normal_profile_count || this.humanPassCount()); }
    public verifiedGroupCount() { return Number(this.liveReview()?.valid_group_count || 0); }
    public normalProfileStatus() { return this.liveReview()?.normal_profile_status || this.batchSummary?.assistant?.source_normal_profile?.status || 'EMPTY'; }
    public auditPercent() { return this.passAuditTarget() ? Math.round(this.passAuditCompleted() * 100 / this.passAuditTarget()) : 0; }
    public hasCompletedExperiment() { return this.experiments.some((item: any) => item?.status === 'completed') || this.jobs.some((item: any) => item?.status === 'completed'); }
    public hasCompletedOperatingPostureExperiment() { return this.experiments.some((item: any) => item?.status === 'completed' && item?.configuration?.profile === 'operating_posture_classifier'); }
    public hasEvaluation() { return this.hasCompletedExperiment() && this.experiments.some((item: any) => item?.evaluation_status === 'EVALUATED' || item?.metrics); }
    public activeTrainingJob() { return this.jobs.find((item: any) => ['queued', 'running'].includes(item?.status)) || null; }
    public hasActiveTrainingJob() { return Boolean(this.activeTrainingJob()); }
    public activeTrainingExperiment() {
        const job = this.activeTrainingJob();
        return job ? this.experiments.find((item: any) => item.id === job.experiment_id) || null : null;
    }
    public activeTrainingLabel() {
        const configuration = this.activeTrainingExperiment()?.configuration || {};
        const profile = configuration?.profile;
        if (configuration?.dataset_source === 'reviewed_pose_reviews') {
            return `${this.displayModelName(configuration?.pose_base_model_id, '운영 Pose 모델')} 업그레이드 · 직접 검수 자료`;
        }
        if (configuration?.dataset_source === 'reviewed_dataset_zip') {
            return `${this.displayModelName(configuration?.pose_base_model_id, '운영 Pose 모델')} 업그레이드 · 검수 ZIP`;
        }
        if (profile === 'yolo_camera_dual') return 'Chest PA YOLO 통합 모델';
        if (profile === 'operating_posture_classifier') return '정상/비정상·4가지 사유 자세 판정 모델';
        return '통합 학습 작업';
    }
    public canGuideTraining() {
        return Boolean(this.pilotSummary?.training_ready)
            && this.verifiedNormalCount() >= 20
            && this.verifiedGroupCount() >= 5
            && this.passAuditRemaining() === 0;
    }
    public trainingBlockReason() {
        const reasons = [];
        if (this.publicPredictionPending() > 0) reasons.push(`공용파일 ${this.publicPredictionPending()}장의 자동 예측과 검수 큐 등록이 남았습니다.`);
        if (this.publicReviewRemaining() > 0) reasons.push(`공용파일 Bucky·Pose 검수가 ${this.publicReviewRemaining()}장 남았습니다.`);
        if (!Number(this.pilotSummary?.manifest_eligible_count || 0)) reasons.push('새 형식으로 명시 저장된 보정 라벨이 필요합니다.');
        if (this.passAuditRemaining() > 0) reasons.push(`PASS 감사가 ${this.passAuditRemaining()}장 남았습니다.`);
        if (this.verifiedNormalCount() < 20) reasons.push(`검증된 정상 PASS가 20장 필요합니다. 현재 ${this.verifiedNormalCount()}장입니다.`);
        if (this.verifiedGroupCount() < 5) reasons.push(`확인된 사람·세션 그룹이 5개 필요합니다. 현재 ${this.verifiedGroupCount()}개입니다.`);
        return reasons.join(' ');
    }
    public currentGuideStep() {
        if (!Number(this.normalityReview()?.total || 0)) return 1;
        if (this.hasActiveTrainingJob()) return 3;
        if (!this.normalityReview()?.trainable) return 2;
        if (this.hasCompletedOperatingPostureExperiment()) {
            return 4;
        }
        return 3;
    }
    public guideStepState(step: number) {
        const current = this.currentGuideStep();
        if (step === 5 && current < 5) return 'locked';
        if (step < current) return 'completed';
        if (step === current) return 'current';
        return 'waiting';
    }
    public guideStepClass(step: number) {
        return ({
            completed: 'border-emerald-300 bg-emerald-50 text-emerald-800',
            current: 'border-sky-400 bg-sky-50 text-sky-900 ring-2 ring-sky-100',
            waiting: 'border-slate-200 bg-white text-slate-500',
            locked: 'border-slate-200 bg-slate-100 text-slate-400',
        } as any)[this.guideStepState(step)];
    }
    public guideStepLabel(step: number) {
        const state = this.guideStepState(step);
        if (state === 'completed') return '완료';
        if (state === 'current' && step === 4) return '결과 확인';
        return state === 'current' ? '진행 중' : state === 'locked' ? '잠금' : '대기';
    }
    public guideStepBadgeClass(step: number) {
        return ({
            completed: 'bg-emerald-100 text-emerald-800',
            current: 'bg-sky-100 text-sky-800',
            waiting: 'bg-slate-100 text-slate-600',
            locked: 'bg-slate-200 text-slate-600',
        } as any)[this.guideStepState(step)];
    }
    public nextActionTitle() {
        const step = this.currentGuideStep();
        if (step === 1) return '검수할 사진·동영상 준비';
        if (step === 2) return '정상/비정상 사람 검수';
        if (step === 3 && this.hasActiveTrainingJob()) return '정상/비정상 분류기 학습 중';
        if (step === 3) return '정상/비정상 분류기 학습';
        if (step === 4) return '새 모델 결과 확인';
        return '외부 검증·운영 승인';
    }
    public nextActionDescription() {
        const step = this.currentGuideStep();
        if (step === 1) return '사진 또는 동영상을 추가하고 새 정상/비정상 검수 큐를 확인해주세요.';
        if (step === 2) return `원본 사진과 동영상 대표 프레임을 보고 새 정답을 저장합니다. 현재 정상 ${this.normalityReview()?.normal || 0}장, 비정상 ${this.normalityReview()?.abnormal || 0}장입니다.`;
        if (step === 3 && this.hasActiveTrainingJob()) return `${this.activeTrainingLabel()} 학습을 실제 worker에서 진행하고 있습니다.`;
        if (step === 3) return '새 사람 검수 라벨과 기존 운영 Pose·Bucky 특징으로 최종 PASS/FAIL 분류기만 학습합니다.';
        if (step === 4) return '사람·세션 분리 성능과 오분류를 확인합니다.';
        return '독립 holdout 검증을 통과한 뒤에만 운영 판정에 반영합니다.';
    }
    public nextActionButtonLabel() {
        if (this.currentGuideStep() === 3 && this.hasActiveTrainingJob()) return '학습 진행 중';
        return ({1: '새 검수 큐 확인', 2: '정상/비정상 검수 시작', 3: '분류기 학습 시작', 4: '평가 결과 확인', 5: '외부 검증 확인'} as any)[this.currentGuideStep()];
    }
    public async runGuidePrimaryAction() {
        const step = this.currentGuideStep();
        if (step <= 2) return this.go('/page.xray/training/normality-review');
        if (step === 3) return this.startOperatingPostureTraining();
        if (step === 4) return this.go('/page.xray/model-manager');
        if (step === 5) return this.go('/page.xray/model-manager');
        return this.go('/page.xray/model-manager');
    }
    public operatingIntegration() {
        return this.yoloPromotion?.operating_model_replaced
            ? 'Chest PA YOLO 통합 모델'
            : this.liveReview()?.operating_integration || 'OFF';
    }
    public automaticApprovalCount() { return Number(this.liveReview()?.automatic_approval_count || this.batchSummary?.assistant?.active_learning?.auto_approved_count || 0); }

    public async setTab(tab: 'posture' | 'detector' | 'judgement') {
        this.activeTab = tab;
        this.storeModelTab(tab);
        const url = new URL(window.location.href);
        url.searchParams.set('model', tab);
        window.history.replaceState(window.history.state, '', url.toString());
        if (tab === 'posture' || tab === 'judgement') {
            const tabItems = tab === 'posture'
                ? this.poseExperiments()
                : this.judgementExperiments();
            if (!tabItems.some((item: any) => item.id === this.selectedExperiment?.id)) {
                this.selectedExperiment = tabItems[0] || null;
                this.selectedJob = this.selectedExperiment
                    ? this.jobs.find((job: any) => job.experiment_id === this.selectedExperiment.id) || null
                    : null;
                this.metrics = null;
                this.evaluationSummary = null;
                this.artifacts = [];
                this.clearPoseCandidateVideo();
                if (this.selectedJob?.status === 'completed') await this.loadResults();
            }
        }
        await this.service.render();
    }

    private isModelTab(value: string | null): value is 'posture' | 'detector' | 'judgement' {
        return value === 'posture' || value === 'detector' || value === 'judgement';
    }

    private readStoredModelTab(): 'posture' | 'detector' | 'judgement' | null {
        try {
            const value = window.localStorage.getItem(this.modelTabStorageKey);
            return this.isModelTab(value) ? value : null;
        } catch {
            return null;
        }
    }

    private storeModelTab(tab: 'posture' | 'detector' | 'judgement') {
        try {
            window.localStorage.setItem(this.modelTabStorageKey, tab);
        } catch {
            // URL query persistence remains available when storage is blocked.
        }
    }

    public clearError() { this.errorMessage = ''; this.service.render(); }

    private restoreSelection() {
        const activeJob = this.activeTrainingJob();
        if (activeJob) {
            this.selectedJob = activeJob;
            this.selectedExperiment = this.experiments.find((item) => item.id === activeJob.experiment_id) || this.selectedExperiment;
            this.startPolling();
            return;
        }
        if (this.selectedExperiment) {
            this.selectedExperiment = this.experiments.find((item) => item.id === this.selectedExperiment.id) || this.experiments[0] || null;
        } else this.selectedExperiment = this.experiments[0] || null;
        if (this.selectedExperiment) this.selectedJob = this.jobs.find((job) => job.experiment_id === this.selectedExperiment.id) || null;
        if (['queued', 'running'].includes(this.selectedJob?.status)) this.startPolling();
    }

    private clearPendingPreviews() {
        for (const item of this.pendingFiles) if (item.url) URL.revokeObjectURL(item.url);
    }

    private emptySummary() {
        return { total: 0, counts: { normal: 0, abnormal: 0 }, corrupt_count: 0, duplicate_count: 0, near_duplicate_group_count: 0, data_paths: [] };
    }

    private callError(error: any, fallback: string) {
        return error?.responseJSON?.message || error?.responseJSON?.detail || error?.message || fallback;
    }
}

export default PageXrayExperimentsComponent;